<template>
    <!--  -->
    <div class="relative">
        <div v-if="formData.details.length"
            class="sticky top-0 left-0 z-10  w-full flex items-center justify-between mt-0 px-6 py-4"
            :class="Math.sign(formData.amount) == -1 ? 'bg-red-200' : 'bg-teal-200'">
            <!--  -->
            <div class="hidden md:flex md:items-center md:w-auto w-full order-3 md:order-1">
                <div class="md:flex items-center justify-between text-base text-blue-600 pt-4 md:pt-0">
                    <svg :class="Math.sign(formData.amount) == -1 ? 'text-red-600' : 'text-teal-600'"
                        class="h-8 w-8 mr-4 inline" viewBox="0 0 20 20" fill="currentColor">
                        <path fill-rule="evenodd"
                            d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
                            clip-rule="evenodd"></path>
                    </svg>
                    <div :class="Math.sign(formData.amount) == -1 ? 'text-red-800' : 'text-teal-800'" class="text-lg inline">
                        {{ formData.details.length + ' orders selected' }}</div>
                </div>
            </div>
            <!--  -->

            <div class="order-2 md:order-3 flex flex-wrap items-center justify-end mr-0 md:mr-4">
                <div class="auth flex items-center w-full md:w-full">
                    <div :class="Math.sign(formData.amount) == -1 ? 'text-red-800' : 'text-teal-800'"
                        class="font-bold text-lg inline">{{ $t('total_amount') }}:
                        <!-- <span>{{(formData.amount).toFixed(2)}} <sup v-if="idWharhouse">({{idWharhouse.currency}})</sup></span> -->

                        <span v-for="(price, j) in formData.amountCurrencySame" :key="j">
                            {{ price.amount.toFixed(2) }} <sup>{{ price.currency }}</sup> <span
                                v-if="j != formData.amountCurrencySame.length - 1">|</span>
                        </span>
                    </div>
                </div>
            </div>
        </div>
        <div class="flex-1 mt-1 bg-gray-100 px-4 pt-12 items-center pb-5">
            <div class="bg-white w-fullrounded-lg shadow form-payement">
                <div class="h-20 py-3 flex items-center border-gray-200 p-6 mt-2">
                    <div class="flex w-1/3">
                        <router-link :class="$colors.primary"
                            class="rounded-full flex justify-center items-center w-8 h-8 mt-1 mr-3" to="/payments">
                            <i class="material-icons mx-2">chevron_left</i>
                        </router-link>
                        <div v-if="!formData._id" class="text-2xl font-bold text-green-500 ">{{ $t('new_payement') }}
                        </div>
                    </div>
                    <div class="w-full flex justify-end space-x-4">
                        <button @click="OpenClosePopPayMethode('open', 'selectOrders')"
                            class="rounded focus:outline-none outline-none text-gray-100 px-3 w-1/6 py-2 bg-green-600  hover:shadow-inner hover:bg-red-700  transition-all duration-300">{{ $t('pay') }}</button>
                    </div>
                </div>
                <div class="">
                    <div class="bg-white rounded-lg p-6 pt-2">
                        <div class="mb-6 border p-4 border-dotted rounded-md border-gray-600 border-2">
                            <div class="flex w-full space-x-2">
                                <div class="flex w-1/2 items-center justify-center">
                                    <div class="w-full space-y-4">
                                        <div
                                            class="border  w-full h-10 hover:border-green-500  focus-within:border-blue-500 focus-within:text-green-500  transition-all duration-500 relative rounded p-1">
                                            <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                                                <p>
                                                    <label for="seller"
                                                        class="bg-white text-gray-700 px-1">{{ $t('select_seller') }}
                                                        <span :class="$colors.required">*</span></label>
                                                </p>
                                            </div>
                                            <p>
                                                <v-select @input="getOrdersBySeller($event, 'seller')"
                                                    @search="searchSellers($event, 'seller')" label="fullName"
                                                    v-model="formData.seller" :options="sellers"></v-select>
                                            </p>
                                        </div>
                                        <div class="border  w-full h-10 hover:border-green-500  focus-within:border-blue-500 focus-within:text-green-500  transition-all duration-500 relative rounded p-1">
                                            <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                                                <p>
                                                    <label for="seller" class="bg-white text-gray-700 px-1">{{ $t('warehouses') }} <span :class="$colors.required">*</span></label>
                                                </p>
                                            </div>
                                            <p>
                                                <v-select label="name" @input="getOrdersBySeller($event, 'warehouses')" v-model="formData.warehouses" :options="warehouses" multiple></v-select>
                                            </p>
                                        </div>
                                        <div class="border mt-4  w-full h-10 hover:border-green-500  focus-within:border-blue-500 focus-within:text-green-500  transition-all duration-500 relative rounded p-1">
                                                <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                                                    <p>
                                                        <label for="seller" class="bg-white text-gray-700 px-1">{{ $t('Type orders') }} </label>
                                                    </p>
                                                </div>
                                                <p>
                                                     <v-select @input="getOrdersBySeller($event, 'warehouses')" disabled v-model="formData.typeOrder" :options="['seller','affiliate','seller-affiliate']"></v-select>
                                                </p>
                                            </div>
                                    </div>

                                </div>
                                <div class="flex w-1/2">
                                    <div class="px-3 w-full">
                                        <div class="inline-block w-full">
                                            <!-- <span class="block mb-3">Date shipping paid:</span>
                                            <div class="inline-block w-full pr-1">
                                                <date-picker placeholder="Range date ..." format="YYYY-MM-DD" type="date" class="w-full-imp  shadow" v-model="intervalDates.from_Date" range></date-picker>
                                            </div> -->
                                            <div class="border mb-5  w-full h-10 hover:border-green-500  focus-within:border-blue-500 focus-within:text-green-500  transition-all duration-500 relative rounded p-1">
                                                <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                                                    <p>
                                                        <label for="seller" class="bg-white text-gray-700 px-1">{{ $t('Date shipping Paid') }} </label>
                                                    </p>
                                                </div>
                                                <p>
                                                    <date-picker placeholder="Range date ..." format="YYYY-MM-DD" type="date" class="w-full-imp" v-model="intervalDates.from_Date" range></date-picker>
                                                </p>
                                            </div>
                                            
                                            <div class="block text-center w-full pr-1 pt-2">
                                                <button @click="FindOrderByBetweenDate"
                                                    :disabled="!intervalDates.from_Date || loadingFind"
                                                    class="mr-2 w-3/12 inline-block relative loidingconfirm  px-4 py-2 text-white font-light tracking-wider bg-red-700 rounded">
                                                    <loading :active.sync="loadingFind" :is-full-page="fullPage">
                                                    </loading> Find
                                                </button>
                                                <button v-if="formData.seller" @click="refresh"
                                                    class="px-2 mr-2  w-3/12 inline-block py-2 text-green-500 hover:text-white font-light tracking-wider bg-gray-300 hover:bg-yellow-600 relative loidingconfirm  rounded"
                                                    :disabled="loadingRefresh">
                                                    <loading :active.sync="loadingRefresh" :is-full-page="fullPage">
                                                    </loading> Refresh <i
                                                        class="material-icons align-bottom">refresh</i>
                                                </button>
                                                <button @click="reset"
                                                    class="w-3/12 inline-block text-center px-2 py-2 text-green-500 hover:text-white font-light tracking-wider bg-gray-300 hover:bg-green-600 rounded relative loidingconfirm"
                                                    :disabled="loadingReset">
                                                    <loading :active.sync="loadingReset" :is-full-page="fullPage">
                                                    </loading>

                                                    <svg class="fill-current inline-block"
                                                        xmlns="http://www.w3.org/2000/svg" width="20" height="20"
                                                        viewBox="0 0 24 24">
                                                        <path
                                                            d="M12 2c5.514 0 10 4.486 10 10s-4.486 10-10 10-10-4.486-10-10 4.486-10 10-10zm0-2c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm6 16.538l-4.592-4.548 4.546-4.587-1.416-1.403-4.545 4.589-4.588-4.543-1.405 1.405 4.593 4.552-4.547 4.592 1.405 1.405 4.555-4.596 4.591 4.55 1.403-1.416z">
                                                        </path>
                                                    </svg>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- <div class="w-full" v-if="formData.seller">
                        <div class="inline-block w-1/3 pr-1">
                            <div class="border hover:border-green-400 w-full focus-within:border-green-500 focus-within:text-green-500 transition-all duration-500 relative rounded p-1">
                            <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs"><p><label for="date" class="bg-white text-gray-700 px-1">From <span class="text-green-500">*</span></label></p></div>
                                <p>  <input  v-model="intervalDates.from_Date" class="w-full px-1 py-1 text-gray-700 bg-gray-200 rounded" id="from" type="date"> </p>
                            </div>
                        </div>
                            <div class="inline-block w-1/3 pr-1">
                            <div class="border hover:border-green-400 w-full focus-within:border-green-500 focus-within:text-green-500 transition-all duration-500 relative rounded p-1">
                            <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs"><p><label for="date" class="bg-white text-gray-700 px-1">To <span class="text-green-500">*</span></label></p></div>
                                <p>  <input  v-model="intervalDates.to_Date" class="w-full px-1 py-1 text-gray-700 bg-gray-200 rounded" id="to" type="date"> </p>
                            </div>
                        </div>
                        <div class="inline-block text-right w-1/3 pr-1">
                            <div class="justify-center flex items-center">
                                <button @click="FindOrderByBetweenDate" :disabled="intervalDates.from_Date==null || intervalDates.to_Date==null" class="w-2/5 mr-2 px-2 py-2 text-white font-light tracking-wider bg-red-700 rounded">Find</button>
                                <button @click="refresh"  class="w-1/4 text-center mr-2 px-2 py-2 text-green-500 hover:text-white font-light tracking-wider bg-gray-300 hover:bg-green-600 rounded">Reset</button>
                                <button @click="reset"  class="w-1/4 text-center px-2 py-2 text-green-500 hover:text-white font-light tracking-wider bg-gray-300 hover:bg-green-600 rounded">
                                  <svg class="fill-current inline-block" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M20.944 12.979c-.489 4.509-4.306 8.021-8.944 8.021-2.698 0-5.112-1.194-6.763-3.075l1.245-1.633c1.283 1.645 3.276 2.708 5.518 2.708 3.526 0 6.444-2.624 6.923-6.021h-2.923l4-5.25 4 5.25h-3.056zm-15.864-1.979c.487-3.387 3.4-6 6.92-6 2.237 0 4.228 1.059 5.51 2.698l1.244-1.632c-1.65-1.876-4.061-3.066-6.754-3.066-4.632 0-8.443 3.501-8.941 8h-3.059l4 5.25 4-5.25h-2.92z"/></svg>
                                </button>
                            </div>
                           
                        </div>
                    </div>  -->
                        </div>
                        <div>
                            <!-- Order selectioner -->
                            <div v-if="orders.length > 0"
                                class="mt-5 overflow-x-auto bg-white rounded-lg shadow overflow-y-auto relative">
                                <div class="w-full  bg-white mt-1 mb-5 shadow-lg border overflow-hidden">
                                    <div
                                        class="py-2 text-center font-bold uppercase tracking-wide text-white bg-red-700">
                                        Seller: {{ formData.seller ? formData.seller.fullName : '' }}</div>
                                    <div class="flex items-center justify-between py-2 px-3 bg-gray-400">
                                        <h1 class="text-gray-800 font-bold ">
                                            <span v-for="(price, j) in totalOrdersAmountFees().dataArray" :key="j">
                                                {{ price.amount.toFixed(2) }} <sup>{{ price.currency }}</sup> <span
                                                    v-if="j != totalOrdersAmountFees().dataArray.length - 1">|</span>
                                            </span>
                                            <span>(Total orders: {{ totalOrdersAmountFees().count }})</span>
                                        </h1>
                                        <button @click="OpenClosePopPayMethode('open', 'allOrders')"
                                            class="bg-gray-800 text-xs text-white px-5 py-1 font-semibold rounded uppercase hover:bg-gray-700 relative loading-amount"
                                            :class="loadingShowPay ? 'disabled-loading' : ''">
                                            <loading :active.sync="loadingShowPay" :is-full-page="fullPage"></loading>
                                            Pay all
                                        </button>
                                    </div>
                                </div>
                                <loading :active.sync="loading" :is-full-page="fullPage"></loading>
                                <table
                                    class="border-collapse table-auto w-full whitespace-no-wrap bg-white table-striped relative">
                                    <thead>
                                        <tr class="text-left">
                                            <th
                                                class="py-1 px-3 sticky top-0 border-b border-gray-200 bg-red-700 text-white  border-gray-300">
                                                <label
                                                    class="text-teal-500 inline-flex justify-between items-center hover:bg-gray-200 px-2 py-2 rounded-lg cursor-pointer">
                                                    <input type="checkbox"
                                                        class="form-checkbox checkallbbox focus:outline-none focus:shadow-outline"
                                                        @click="selectAllCheckbox($event);">
                                                </label>
                                            </th>
                                            <th v-for="(heading, ind) in headings" :key="ind"
                                                class="text-center px-1 text-xss font-bold uppercase bg-red-700 text-white border border-gray-300">
                                                {{ heading.value }}</th>
                                        </tr>
                                    </thead>
                                    <tableBody v-for="(order, ind) in orders" :key="ind" :item="order"
                                        :servicesSeller="servicesSeller" :options="dataCountry" :warehouses="warehouses"
                                        :citiesPrices="citiesPrices" :warehouse="warehouse" :idWharhouse="idWharhouse"
                                        :qu_control="quality_control" :confvat="confirmation_vat"
                                        :upsellvat="upsell_vat" :fulvat="fulfillement_fees_vat" :ship_vat="shipping_vat"
                                        :ship_refund_vat="shipping_refund_vat" :ship_cancel_vat="shipping_cancel_vat"
                                        :formData="formData" :settingsFees="settingsFees" @getRowDetail="getRowDetail"
                                        @UpdateRowFees="UpdateRowFees" />
                                </table>
                                <!-- Expedition -->
                                <table v-if="expeditions.length > 0" class="min-w-full">
                                    <thead>
                                        <tr>
                                            <th :colspan="7"
                                                class="text-center bg-gray-200 px-6 py-3 border-b-2 border-t-2 border-gray-300 text-left leading-4 text-green-500  tracking-wider">
                                                Expeditions</th>
                                        </tr>
                                    </thead>
                                    <thead>
                                        <tr>
                                            <th
                                                class="text-center bg-gray-100 px-6 py-3 border-b-2 border-t-2 border-gray-300 text-left leading-4 text-green-500  tracking-wider">
                                            </th>
                                            <th
                                                class="text-center bg-gray-100 px-6 py-3 border-b-2 border-t-2 border-gray-300 text-left leading-4 text-green-500  tracking-wider">
                                                {{ $t('nb_packages') }}</th>
                                            <th
                                                class="text-center bg-gray-100 px-6 py-3 border-b-2 border-t-2 border-gray-300 text-left leading-4 text-green-500  tracking-wider">
                                                {{ $t('transport_mode') }}</th>
                                            <th
                                                class="text-center bg-gray-100 px-6 py-3 border-b-2 border-t-2 border-gray-300 text-left leading-4 text-green-500  tracking-wider">
                                                {{ $t('details') }}</th>
                                            <th
                                                class="text-center bg-gray-100 px-6 py-3 border-b-2 border-t-2 border-gray-300 text-left leading-4 text-green-500  tracking-wider">
                                                {{ $t('country') }}</th>
                                            <th
                                                class="text-center bg-gray-100 px-6 py-3 border-b-2 border-t-2 border-gray-300 text-left leading-4 text-green-500  tracking-wider">
                                                {{ $t('expedition_fees') }}</th>
                                        </tr>
                                    </thead>
                                    <tbody class="bg-white">
                                        <tr v-for="(exp, ind) in expeditions" :key="ind">
                                            <td class="px-6 py-2 whitespace-no-wrap border-b-2 border-r-2 text-center">
                                                <input type="checkbox" :id="exp._id"
                                                    @click="getRowDetailExp($event, exp, exp._id)"
                                                    class="form-checkbox checkbox-exp focus:outline-none focus:shadow-outline">
                                            </td>
                                            <td class="px-6 py-2 border-b-2 whitespace-no-wrap border-b-2 text-center">
                                                <div class="text-sm leading-5 text-blue-900 capitalize ">
                                                    {{ exp.numberOfPackages }}</div>
                                            </td>
                                            <td class="px-6 py-2 border-b-2 whitespace-no-wrap border-b-2 text-center">
                                                <div class="text-sm leading-5 text-blue-900 capitalize ">
                                                    {{ exp.transportMode }}</div>
                                            </td>
                                            <td class="px-6 py-2 border-b-2 whitespace-no-wrap border-b-2 text-center">
                                                <div class="text-sm leading-5 text-blue-900 capitalize ">
                                                    {{ exp.details.length }} {{ $t('products') }}</div>
                                            </td>
                                            <td class="px-6 py-2 border-b-2 whitespace-no-wrap border-b-2 text-center">
                                                <div class="text-sm leading-5 text-blue-900 capitalize ">{{ exp.country }}
                                                </div>
                                            </td>
                                            <td class="px-6 py-2 border-b-2 whitespace-no-wrap border-b-2 text-center">
                                                <div class="text-sm leading-5 font-bold text-blue-900 capitalize ">
                                                    {{ exp.fees }}</div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <!--order by seller-->
                            <div class="mt-6" style="overflow-x: auto;" v-if="orders.length == 0">
                                <table class="min-w-full w-full">
                                    <thead class="relative">
                                        <tr class="bg-gray-400 text-gray-600 uppercase text-sm leading-normal">
                                            <th
                                                class="px-3 py-2 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-800 uppercase tracking-wider">
                                                <span> Seller </span></th>
                                            <th
                                                class="px-3 py-2 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-800 uppercase tracking-wider">
                                                <span> Country </span></th>
                                            <th
                                                class="px-3 py-2 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-800 uppercase tracking-wider text-center">
                                                <span> Number of orders </span></th>
                                            <th
                                                class="px-3 py-2 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-800 uppercase tracking-wider text-center">
                                                <span> Amount to pay </span></th>
                                            <th
                                                class="px-3 py-2 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-800 uppercase tracking-wider text-center">
                                                <span> Action </span></th>
                                        </tr>
                                    </thead>
                                    <loading :active.sync="loadingorderbyseller" :is-full-page="fullPage"></loading>
                                    <tableTotalAmount v-for="(totalorders, index) in ordersByseller" :key="index"
                                        :sellerSelect="sellerSelect"
                                        :country="formData.warehouses.map(el => el.country)"
                                        :loadingShowPay="loadingShowPay" :item="totalorders"
                                        :citiesPrices="citiesPrices" :warehouse="warehouse" :idWharhouse="idWharhouse"
                                        @getOrdersBySeller="getOrdersBySeller"
                                        @OpenClosePopPayMethode="OpenClosePopPayMethode" />
                                </table>
                                <!-- <div v-if="ordersByseller.length==0" class="bg-blue-100 py-8">
                                <span class="w-full flex justify-center text-center py-3 border-b border-gray-200 text-base">
                                    No order to pay
                                </span>
                            </div>-->
                            </div>
                            <!--/order by seller-->
                            <div v-if="!formData.seller && ordersByseller.length == 0"
                                class="relative bg-blue-100 py-8 mt-1">
                                <loading :active.sync="loading" :is-full-page="fullPage"></loading>
                                <span
                                    class="w-full flex justify-center text-center py-3 border-b border-gray-200 text-base">
                                    <p class="font-semibold flex text-green-500  whitespace-no-wrap">
                                        <i class="material-icons mx-3">error</i>
                                        <span>No order to paid </span>
                                    </p>
                                </span>
                            </div>
                            <div v-if="formData.seller && orders.length == 0 && formData.details.length == 0 && ordersByseller.length == 0"
                                class="relative bg-blue-100 py-8 mt-1">
                                <loading :active.sync="loading" :is-full-page="fullPage"></loading>
                                <span
                                    class="w-full flex justify-center text-center py-3 border-b border-gray-200 text-base">
                                    <p class="font-semibold flex text-green-500 whitespace-no-wrap">
                                        <i class="material-icons mx-3">error</i>
                                        <span>No order to paid for this Seller</span>
                                    </p>
                                </span>
                            </div>
                            <!--pagination -->
                            <div class="p-1" v-if="paginate.lastpage > 1">
                                <div class="flex flex-col items-center my-12">
                                    <button v-if="paginate.currentpage < paginate.lastpage"
                                        :disabled="paginate.currentpage == paginate.lastpage" @click="loadMore"
                                        class="custom-btn btn-16">Show more data</button>

                                </div>
                            </div>
                            <!--end pagination -->
                            <!--end  Order selectioner -->

                        </div>
                    </div>
                </div>
            </div>
        </div>
        <vue-modal-2 name="ModalPay" :headerOptions="{ title: $t('Generation Payment') }" :noFooter="true" modalSize="lg">
            <vue-ins-progress-bar></vue-ins-progress-bar>
            <loading :active.sync="loadingPay" :is-full-page="fullPage"></loading>
            <div class="bg-white rounded-lg">
                <div v-if="sendEmailData.loading == 'envoi'"
                    class="bg-blue-100 border-t border-b border-blue-500 text-blue-700 px-4 py-3 box-email"
                    role="alert">
                    <p class="font-bold">Envoi d'Email au Seller</p>
                    <p class="text-sm">Envoi <svg class="inline-block" width="24" height="24" viewBox="0 0 24 24"
                            xmlns="http://www.w3.org/2000/svg">
                            <circle class="spinner_S1WN" cx="4" cy="12" r="3" />
                            <circle class="spinner_S1WN spinner_Km9P" cx="12" cy="12" r="3" />
                            <circle class="spinner_S1WN spinner_JApP" cx="20" cy="12" r="3" />
                        </svg></p>
                </div>
                <div class="rounded-lg p-4 pt-0">
                    <!-- <h3 class="font-bold text-green-600 mb-5">{{ $t('Generation Payment') }}</h3> -->
                       
                       <div class="tab-pay">
                           <div class="w-full">
                               <div
                                   class="mb-3 border hover:border-green-500  focus-within:border-blue-500 focus-within:text-green-500  transition-all duration-500 relative rounded p-1">
                                   <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                                       <p>
                                           <label for="country"
                                               class="bg-white text-gray-700 px-1">{{ $t('payement_methode') }}</label>
                                       </p>
                                   </div>
                                   <p>
                                       <v-select @input="setSelected" v-model="formData.method" :options="options"
                                           label="name">
                                           <template slot="option" slot-scope="option">
                                               <img class="flag-img" :src="getImagePay(option.name)" />
                                               {{ option.name }}
                                           </template>
                                       </v-select>
                                   </p>
                               </div>
                           </div>
                           <div class="header-tabl app-theme mt-2">
                               <div class="w-full flex justify-center">
                                   <div class="title title-1">
                                       <button @click="AddRefunds('Remboursements')" id="invoice-item-add"
                                           title="Add Item" class="btn mt-1 btn-prime loidingconfirm relative"
                                           :class="loadingPay || (sendEmailData.loading == 'envoi') ? 'noselect' : ''">
                                           <loading v-if="dataType == 'Remboursements'" :active.sync="loadingPay"
                                               :is-full-page="fullPage">
                                           </loading>Ajouter des remboursements<svg
                                               class="svg-inline--fa_2 fa-plus ml-2 fa-w-14 text-white fill-current"
                                               xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                               viewBox="0 0 24 24">
                                               <path
                                                   d="M12 2c5.514 0 10 4.486 10 10s-4.486 10-10 10-10-4.486-10-10 4.486-10 10-10zm0-2c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm6 13h-5v5h-2v-5h-5v-2h5v-5h2v5h5v2z" />
                                           </svg>
                                       </button>
                                       <button @click="AddRefunds('Expeditions')" id="invoice-item-add"
                                           title="Add Item" class="btn ml-1 mt-1 btn-prime loidingconfirm relative"
                                           :class="loadingPay || (sendEmailData.loading == 'envoi') ? 'noselect' : ''">
                                           <loading v-if="dataType == 'Expeditions'" :active.sync="loadingPay"
                                               :is-full-page="fullPage"></loading>
                                           Ajouter des expeditions<svg
                                               class="svg-inline--fa_2 fa-plus ml-2 fa-w-14 text-white fill-current"
                                               xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                               viewBox="0 0 24 24">
                                               <path
                                                   d="M12 2c5.514 0 10 4.486 10 10s-4.486 10-10 10-10-4.486-10-10 4.486-10 10-10zm0-2c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm6 13h-5v5h-2v-5h-5v-2h5v-5h2v5h5v2z" />
                                           </svg>
                                       </button>
                                       <button @click="AddRefunds('Charges')" id="invoice-item-add" title="Add Item"
                                           class="btn ml-1 mt-1 btn-prime loidingconfirm relative"
                                           :class="loadingPay || (sendEmailData.loading == 'envoi') ? 'noselect' : ''">
                                           <loading v-if="dataType == 'Charges'" :active.sync="loadingPay"
                                               :is-full-page="fullPage"></loading>
                                           Ajouter des charges<svg
                                               class="svg-inline--fa_2 fa-plus ml-2 fa-w-14 text-white fill-current"
                                               xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                               viewBox="0 0 24 24">
                                               <path
                                                   d="M12 2c5.514 0 10 4.486 10 10s-4.486 10-10 10-10-4.486-10-10 4.486-10 10-10zm0-2c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm6 13h-5v5h-2v-5h-5v-2h5v-5h2v5h5v2z" />
                                           </svg>
                                       </button>
                                   </div>
                               </div>
                           </div>
                       </div>
                </div>
                <div class="w-96 rounded-lg flex" style="margin-bottom: 76px;">
                    <div class="w-1/3 flex justify-center items-center">
                        <span class="w-16 h-16 bg-green-600  text-white p-3 rounded-full"><i class="material-icons"
                                style="font-size: 40px;">payment</i></span>
                    </div>
                    <div class="w-full pr-4">
                   

                        <table class="invoice-table table table-borderless table-nowrap mb-0 w-full">
                            <thead class="align-middle">
                                <tr>
                                    <th></th>
                                    <!-- <th></th>
                                    <th></th>
                                    <th></th>
                                    <th></th>
                                    <th></th> -->
                                </tr>
                            </thead>
                            <tbody>
                                <tr class="mt-2">
                                    <!-- <td class="w-1/6" colspan="3"></td> -->
                                    <td colspan="2" class="p-0">
                                        <table
                                            class="table table-borderless table-sm table-nowrap align-middle mb-0 w-full">
                                            <tbody>
                                                <tr>
                                                    <th scope="row">Seller</th>
                                                    <td style="width:150px;">
                                                        <div class="form-control bg-light border-0 font-bold-imp"
                                                            readonly="">
                                                            {{ formData.seller ? formData.seller.fullName : '' }}
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr v-if="intervalDates.from_Date && filters.from_Date">
                                                    <th scope="row">Période Date</th>
                                                    <td style="width:150px;">
                                                        <div class="form-control bg-light border-0" readonly="">
                                                            [{{ filters.from_Date }}]
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th scope="row">Warehouses</th>
                                                    <td style="width:150px;">
                                                        <div class="form-control bg-light border-0" readonly="">
                                                            <div class="flex leading-5 capitalize rounded-full">
                                                                <span
                                                                    v-for="(images, r) in formData.warehouses.map(el => el.flag)"
                                                                    :key="r">
                                                                    <img :src="images"
                                                                        class="w-4 h-4 rounded-full mr-2">
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>

                                                <tr>
                                                    <th scope="row">Sub Total <small>({{ formData.details.length }}
                                                            orders)</small></th>
                                                    <td style="width:150px;">

                                                        <div class="form-control bg-light border-0" readonly="">
                                                            <span v-for="(price, j) in formData.amountCurrencySame"
                                                                :key="j">
                                                                {{ price.totalPrice.toFixed(2) }}
                                                                <sup>{{ price.currency }}</sup> <span v-if="j != formData.amountCurrencySame.length - 1">|</span>
                                                            </span>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th scope="row">Total Fees <small>(Shipping Fees)</small></th>
                                                    <td>
                                                        <div class="form-control bg-light border-0" readonly="">
                                                            <span v-for="(price, j) in formData.amountCurrencySame" :key="j">
                                                                {{ price.fees.toFixed(2) }} 
                                                                <sup>{{ price.currency }}</sup> <span v-if="j != formData.amountCurrencySame.length - 1">|</span>
                                                            </span>
                                                        </div>
                                                    </td>
                                                </tr>

                                                <tr v-if="formData.refunds.length > 0">
                                                    <th scope="row">Remboursements <small>({{ formData.refunds.length }}orders)</small></th>
                                                    <td>
                                                        <div class="form-control bg-light border-0" readonly="">
                                                            <span v-for="(price, j) in formData.amountRefundsCurrencySame" :key="j">
                                                                {{ price.fees_amount.toFixed(2) }}
                                                                <sup>{{ price.currency }}</sup> <span v-if="j != formData.amountRefundsCurrencySame.length - 1">|</span>
                                                            </span>
                                                        </div>
                                                    </td>
                                                </tr>

                                                <tr v-if="formData.expeditions.length > 0">
                                                    <th scope="row">Expeditions
                                                        <small>({{ formData.expeditions.length }})</small></th>
                                                    <td>
                                                        <div class="form-control bg-light border-0" readonly="">
                                                            <span
                                                                v-for="(price, j) in formData.amountExpeditionsCurrencySame"
                                                                :key="j">
                                                                {{ price.fees_amount.toFixed(2) }}
                                                                <sup>{{ price.currency }}</sup> <span v-if="j != formData.amountExpeditionsCurrencySame.length - 1">|</span>
                                                            </span>
                                                        </div>
                                                    </td>
                                                </tr>

                                                <tr v-if="formData.charges.length > 0">
                                                    <th scope="row">(-) Charges <small>({{ formData.charges.length }})</small>
                                                    </th>
                                                    <td>
                                                        <div class="form-control bg-light border-0" readonly="">
                                                            <span v-for="(price, j) in formData.amountChargesCurrencySame" :key="j">
                                                                {{ price.fees_amount.toFixed(2) }}
                                                                <sup>{{ price.currency }}</sup>  <span v-if="j != formData.amountChargesCurrencySame.length - 1">|</span>
                                                            </span>
                                                        </div>
                                                    </td>
                                                </tr>

                                                <tr v-if="formData.primes.length > 0">
                                                    <th scope="row">(+) Charges rembourser <small>({{ formData.primes.length }})</small>
                                                    </th>
                                                    <td>
                                                        <div class="form-control bg-light border-0" readonly="">
                                                            <span v-for="(price, j) in formData.amountPrimesCurrencySame" :key="j">
                                                                {{ price.fees_amount.toFixed(2) }}
                                                                <sup>{{ price.currency }}</sup>  <span v-if="j != formData.amountPrimesCurrencySame.length - 1">|</span>
                                                            </span>
                                                        </div>
                                                    </td>
                                                </tr>


                                                <tr class="border-top border-top-dashed">
                                                    <th scope="row">Total Amount</th>
                                                    <td>
                                                        <div class="form-control bg-light border-0 font-bold-imp" readonly="">
                                                            <span v-for="(price, j) in formData.amountCurrencySame"
                                                                :key="j">
                                                                {{ price.amount.toFixed(2) }}
                                                                <sup>{{ price.currency }}</sup> <span
                                                                    v-if="j != formData.amountCurrencySame.length - 1">|</span>
                                                            </span>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        <!--end table-->
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>


            </div>
            <div class="modal-footer  px-5 border0-t text-right">
                <a href="#" :class="loadingPay || (sendEmailData.loading == 'envoi') ? 'noselect' : ''"
                    @click="OpenClosePopPayMethode('close')"
                    class="flex text-white mx-auto max-w-sm rounded text-center bg-gray-500 py-2 px-8 items-center focus:outline-none md:float-right">{{ $t('cancel') }}</a>
                <a href="#" :class="loadingPay || (sendEmailData.loading == 'envoi') ? 'noselect' : ''" @click="save"
                    class="flex mr-2 text-white mx-auto max-w-sm rounded text-center bg-green-600 py-2 px-8 items-center focus:outline-none md:float-right loidingconfirm relative">{{ $t('confirm') }}</a>
                <table
                    class="animation-pulse invoice-table table table-borderless table-nowrap flex  mx-auto max-w-sm rounded text-center items-center focus:outline-none md:float-left">
                    <thead class="align-middle">
                        <tr>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr class="border-left border-left-dashed">
                            <th scope="row" class="px-1">Total Amount</th>
                            <td class="">
                                <div class="form-control bg-light border-0 font-bold-imp" readonly="">
                                    <span v-for="(price, j) in formData.amountCurrencySame" :key="j">
                                        {{ price.amount.toFixed(2) }} <sup>{{ price.currency }}</sup> <span
                                            v-if="j != formData.amountCurrencySame.length - 1">|</span>
                                    </span>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </vue-modal-2>

        <vue-modal-2 class="codinafrica" name="ModalRefunds" :headerOptions="{ title: dataType }" :noFooter="true"
            modalSize="xl">
            <div class="flex flex-col w-full h-auto p-5 pt-0  bottom_bitt">
                <div class="align-middle inline-block min-w-full overflow-hidden bg-white shadow-dashboard rounded-bl-lg rounded-br-lg"
                    style="margin-bottom: 62px;">
                    <table class="min-w-full">
                        <caption style="background-color: #d7d7d7;">
                            <span v-if="dataType == 'Remboursements'">{{ `${formData.refunds.length} ${dataType}
                                sélectionnées`
                                }}</span>
                            <span v-else-if="dataType == 'Expeditions'">{{ `${formData.expeditions.length} ${dataType}
                                sélectionnées` }}</span>
                            <span v-else>{{ `${formData.charges.length + formData.primes.length} ${dataType} sélectionnées` }}</span>
                        </caption>
                        <thead>
                            <tr>
                                <th width="10"
                                    class="px-3 py-1 siz12 bg-gray-200 border-b-2 border-t-2 border-gray-300 text-left leading-4  text-green-600  tracking-wider">
                                </th>

                                <template v-if="dataType == 'Remboursements'">
                                    <th
                                        class="px-3 py-1 siz12 bg-gray-200 border-b-2 border-t-2 border-gray-300 text-left leading-4  text-green-600  tracking-wider">
                                        ORDER_ID</th>
                                    <th
                                        class="px-3 py-1 siz12 bg-gray-200 border-b-2 border-t-2 border-gray-300 text-left text-sm leading-4  text-green-600  tracking-wider">
                                        {{ $t('customer') }}</th>
                                    <th
                                        class="px-3 py-1 siz12 bg-gray-200 border-b-2 border-t-2 border-gray-300 text-left text-sm leading-4  text-green-600  tracking-wider">
                                        {{ $t('traking_number') }}</th>
                                    <th
                                        class="px-3 py-1 siz12 bg-gray-200 border-b-2 border-t-2 border-gray-300 text-left text-sm leading-4  text-green-600  tracking-wider">
                                        {{ $t('details') }}</th>
                                    <th
                                        class="px-3 py-1 siz12 bg-gray-200 border-b-2 border-t-2 border-gray-300 text-left text-sm leading-4  text-green-600  tracking-wider">
                                        {{ $t('total_price') }}</th>
                                    <th
                                        class="px-3 py-1 siz12 bg-gray-200 border-b-2 border-t-2 border-gray-300 text-left text-sm leading-4  text-green-600  tracking-wider">
                                        {{ $t('warehouse') }}</th>
                                    <th
                                        class="px-3 py-1 siz12 bg-gray-200 border-b-2 border-t-2 border-gray-300 text-left text-sm leading-4  text-green-600  tracking-wider">
                                        {{ $t('status') }}</th>
                                </template>

                                <template v-if="dataType == 'Expeditions'">
                                    <th
                                        class="px-3 py-1 siz12 bg-gray-200 border-b-2 border-t-2 border-gray-300 text-left text-sm leading-4  text-green-600  tracking-wider">
                                        ID</th>
                                    <th
                                        class="px-3 py-1 siz12 bg-gray-200 border-b-2 border-t-2 border-gray-300 text-left text-sm leading-4  text-green-600  tracking-wider">
                                        POIDS (KG)</th>
                                    <th
                                        class="px-3 py-1 siz12 bg-gray-200 border-b-2 border-t-2 border-gray-300 text-left text-sm leading-4  text-green-600  tracking-wider">
                                        NUMBER OF PACKAGES</th>
                                    <th
                                        class="px-3 py-1 siz12 bg-gray-200 border-b-2 border-t-2 border-gray-300 text-left text-sm leading-4  text-green-600  tracking-wider">
                                        EXPEDITION FEES</th>
                                    <th
                                        class="px-3 py-1 siz12 bg-gray-200 border-b-2 border-t-2 border-gray-300 text-left text-sm leading-4  text-green-600  tracking-wider">
                                        RECEPTION DATE</th>
                                    <th
                                        class="px-3 py-1 siz12 bg-gray-200 border-b-2 border-t-2 border-gray-300 text-left text-sm leading-4  text-green-600  tracking-wider">
                                        DETAILS</th>
                                    <th
                                        class="px-3 py-1 siz12 bg-gray-200 border-b-2 border-t-2 border-gray-300 text-left text-sm leading-4  text-green-600  tracking-wider">
                                        FROM</th>
                                    <th
                                        class="px-3 py-1 siz12 bg-gray-200 border-b-2 border-t-2 border-gray-300 text-left text-sm leading-4  text-green-600  tracking-wider">
                                        TO</th>

                                    <th
                                        class="px-3 py-1 siz12 bg-gray-200 border-b-2 border-t-2 border-gray-300 text-left text-sm leading-4  text-green-600  tracking-wider">
                                        {{ $t('type') }}</th>
                                </template>

                                <template v-if="dataType == 'Charges'">
                                    <th
                                        class="px-3 py-1 siz12 bg-gray-200 border-b-2 border-t-2 border-gray-300 text-left text-sm leading-4  text-green-600  tracking-wider">
                                        ID</th>
                                    <th
                                        class="px-3 py-1 siz12 bg-gray-200 border-b-2 border-t-2 border-gray-300 text-left text-sm leading-4  text-green-600  tracking-wider">
                                        COMMENT</th>
                                    <th
                                        class="px-3 py-1 siz12 bg-gray-200 border-b-2 border-t-2 border-gray-300 text-left text-sm leading-4  text-green-600  tracking-wider">
                                        Type</th>
                                    <th
                                        class="px-3 py-1 siz12 bg-gray-200 border-b-2 border-t-2 border-gray-300 text-left text-sm leading-4  text-green-600  tracking-wider">
                                        {{ $t('warehouse') }}</th>
                                    <th
                                        class="px-3 py-1 siz12 bg-gray-200 border-b-2 border-t-2 border-gray-300 text-left text-sm leading-4  text-green-600  tracking-wider">
                                        DATE</th>
                                    <th
                                        class="px-3 py-1 siz12 bg-gray-200 border-b-2 border-t-2 border-gray-300 text-left text-sm leading-4  text-green-600  tracking-wider">
                                        AMOUNT</th>
                                </template>

                            </tr>
                        </thead>

                        <tbody class="bg-white" v-if="dataType == 'Remboursements'">
                            <tr v-for="(order, ind) in refunds" :key="ind">
                                <td width="10" class="border-t-2 border-gray-300 px-3">
                                    <label
                                        class="text-teal-500 inline-flex justify-between items-center hover:bg-gray-200 px-2 py-1 rounded-lg cursor-pointer">
                                        <input type="checkbox" :id="order.orderObjet._id"
                                            @click="getRowDetailRefund($event, order, order.order._id || order.order, dataType)"
                                            class="form-checkbox rowCheckbox_refund focus:outline-none focus:shadow-outline">
                                    </label>
                                </td>
                                <td class="border-t-2 border-gray-300 px-3 py-1">
                                    <div class="flex items-center">
                                        <div>
                                            <div class="text-sm leading-5 text-gray-800">{{ order.orderObjet.id }}</div>
                                        </div>
                                    </div>
                                </td>

                                <td class="border-t-2 border-gray-300 px-3 py-1" style="font-size: 11px;">
                                    <div class="leading-5 text-blue-900 capitalize" v-if="order.orderObjet.customer">
                                        {{ order.orderObjet.customer.fullName }}</div>
                                    <div v-if="order.orderObjet.customer" class="font-light text-gray-700 text-smm">
                                        {{ order.orderObjet.customer.phone }}</div>
                                </td>
                                <td class="border-t-2 border-gray-300 px-3 py-1">
                                    <div class="text-sm leading-5 siz12 text-blue-900">{{ order.trackingNumber }}</div>
                                </td>

                                <td class="border-t-2 border-gray-300 px-3 py-1">
                                    <div class="text-sm leading-5 text-blue-900">{{ order.orderObjet.details.map(item =>
                                        item.quantity).reduce((prev, curr) => prev + curr, 0)}} {{ $t('products') }}</div>
                                </td>
                                <td class="px-3 py-2 text-left border-t-2 border-gray-300 whitespace-no-wrap">
                                    <div class="text-sm leading-5 text-blue-900">{{ order.orderObjet.totalPrice }} <sup>{{
                                            getCurrencyByCode(order.orderObjet.customer.country) }}</sup></div>
                                </td>
                                <td class="border-t-2 border-gray-300 px-3 py-1">
                                    <div class="text-sm leading-5 siz12 text-blue-900"> {{
                                        $f.getCountryNameByCode(optionsCountries,order.orderObjet.customer.country) }}
                                    </div>
                                </td>
                                <td class="border-t-2 border-gray-300 px-3 py-1 text-center">
                                    <div
                                        class="text-sm bg-red-600 leading-5 px-2 rounded-full text-xs text-white cursor-pointer font-medium">
                                        {{ order.status }}</div>
                                </td>
                            </tr>
                        </tbody>

                        <tbody class="bg-white" v-if="dataType == 'Expeditions'">
                            <tr v-for="(order, ind) in expeditions" :key="ind">
                                <td width="10" class="border-t-2 border-gray-300 px-3">
                                    <label
                                        class="text-teal-500 inline-flex justify-between items-center hover:bg-gray-200 px-2 py-1 rounded-lg cursor-pointer">
                                        <input type="checkbox" :id="order._id"
                                            @click="getRowDetailRefund($event, order, order._id, dataType)"
                                            class="form-checkbox rowCheckbox_expedition focus:outline-none focus:shadow-outline">
                                    </label>
                                </td>
                                <td class="border-t-2 border-gray-300 px-3 py-1">
                                    <div class="flex items-center">
                                        <div>
                                            <div class="text-sm leading-5 text-gray-800">{{ order.id }}</div>
                                        </div>
                                    </div>
                                </td>

                                <td class="border-t-2 border-gray-300 px-3 py-1">
                                    <div class="text-sm leading-5 siz12 text-blue-900">{{ (order.type && order.type ==
                                        'expedition') || !order.type ?order.weight:''}} </div>
                                </td>
                                <td class="border-t-2 border-gray-300 px-3 py-1">
                                    <div class="text-sm leading-5 siz12 text-blue-900">{{ order.type && order.type ==
                                        'transfer'?order.numberOfPackages:''}} </div>
                                </td>

                                <td class="px-3 py-2 text-left border-t-2 border-gray-300 whitespace-no-wrap">
                                    <div class="text-sm leading-5 text-blue-900">{{ order.fees }} <sup>{{
                                            getCurrencyByCode(order.country_to) }}</sup></div>
                                </td>

                                <td class="border-t-2 border-gray-300 px-3 py-1">
                                    <div class="text-sm leading-5 text-blue-900 ">
                                        {{ $moment(order.arrivalDate).format('yyyy-MM-DD') }}</div>
                                </td>
                                <td class="border-t-2 border-gray-300 px-3 py-1">
                                    <div class="text-sm leading-5 text-blue-900">{{ order.details.length }} Products</div>
                                </td>

                                <td class="border-t-2 border-gray-300 px-3 py-1">
                                    <div class="text-sm leading-5 siz12 text-blue-900"> {{
                                        $f.getCountryNameByCode(optionsCountries,order.country) }}</div>
                                </td>
                                <td class="border-t-2 border-gray-300 px-3 py-1">
                                    <div class="text-sm leading-5 siz12 text-blue-900"> {{
                                        $f.getCountryNameByCode(optionsCountries,order.country_to) }}</div>
                                </td>


                                <td class="border-t-2 border-gray-300 px-3 py-1 text-center">
                                    <div :class="order.type && order.type == 'transfer' ? 'bg-red-600' : 'bg-blue-600'"
                                        class="text-sm  leading-5 px-2 rounded-full text-xs text-white cursor-pointer font-medium">
                                        {{ order.type }}</div>
                                </td>

                            </tr>
                        </tbody>

                        <tbody class="bg-white" v-if="dataType == 'Charges'">
                            <tr v-for="(order, ind) in charges" :key="ind" :class="order.type === 'remboursement' ? 'exp-prime' : 'exp-avance' ">
                                <td width="10" class="border-t-2 border-gray-300 px-3">
                                    <label
                                        class="text-teal-500 inline-flex justify-between items-center hover:bg-gray-200 px-2 py-1 rounded-lg cursor-pointer">
                                        <input type="checkbox" :id="order._id"
                                            @click="getRowDetailRefund($event, order, order._id, dataType)"
                                            class="form-checkbox rowCheckbox_charge focus:outline-none focus:shadow-outline">
                                    </label>
                                </td>
                                <td class="border-t-2 border-gray-300 px-3 py-1">
                                    <div class="flex items-center">
                                        <div>
                                            <div class="text-sm leading-5 text-gray-800">{{ order.id }}</div>
                                        </div>
                                    </div>
                                </td>

                                <td class="border-t-2 border-gray-300 px-3 py-1">
                                    <div class="text-sm leading-5 siz12 text-blue-900">{{ order.comment }} </div>
                                </td>
                                <td class="border-t-2 border-gray-300 px-3 py-1">
                                    <div class="text-sm leading-5 siz12 text-blue-900">{{ order.type }} </div>
                                </td>
                                <td class="border-t-2 border-gray-300 px-3 py-1">
                                    <div class="text-sm leading-5 siz12 text-blue-900"> {{ order.warehouse.name }}</div>
                                </td>

                                <td class="border-t-2 border-gray-300 px-3 py-1">
                                    <div class="text-sm leading-5 text-blue-900 ">
                                        {{ $moment(order.date).format('yyyy-MM-DD') }}
                                    </div>
                                </td>

                                <td class="px-3 py-2 text-left border-t-2 border-gray-300 whitespace-no-wrap">
                                    <div class="text-sm leading-5 text-blue-900">(-) {{ order.amount }} <sup>{{getCurrencyByCode(order.warehouse.country) }}</sup> </div>
                                </td>
                            </tr>
                        </tbody>

                    </table>

                </div>

            </div>

            <div class="modal-footer px-5 border0-t text-right">
                <button @click="OpenClosePopPayMethode('close', dataType)"
                    class="flex text-white mx-auto max-w-sm rounded text-center bg-gray-500 py-2 px-8 items-center focus:outline-none md:float-right">Cancel</button>
                <button @click="AddRefunds('addRefunds', 'confirm')"
                    class="flex mr-2 text-white mx-auto max-w-sm rounded text-center bg-blue-500 py-2 px-8 items-center focus:outline-none md:float-right">Confirm</button>
            </div>
        </vue-modal-2>

        <dialog class="invoicePayment">
            <invoice-payment id="detailInvoice" v-if="sendEmailData.data._id" :idPayment="sendEmailData.data._id || ''"
                :idWharhouse="idWharhouse" :currentUser="currentUser" />
        </dialog>
    </div>
    <!--  -->
</template>

<script>
import tableBody from '@/views/payments/tableOrders.vue'
import tableTotalAmount from '@/views/payments/tableTotalAmount.vue'
import image1 from '@/assets/pay/cash.png'
import image2 from '@/assets/pay/paypal.png'
import image3 from '@/assets/pay/transfer.png'

export default {
    components: {
        tableBody, tableTotalAmount
    },
    props: {
        currentUser: { type: Object },
        idWharhouse: { type: Object }
    },
    data() {
        return {
            formData: {
                seller: null,
                date: Date.now(),
                amount: 0,
                details: [],
                expeditions: [],
                refunds: [],
                charges: [],
                primes: [],
                warehouses: [],
                method: "cash",
                amountCurrency: [],
                amountExpeditionsCurrency: [],
                amountRefundsCurrency: [],
                amountChargesCurrency: [],
                amountPrimesCurrency: [],
                info: {},
                infoCurrency: [],
                typeOrder:'seller-affiliate'
            },
            intervalDates: {
                from_Date: null,
                to_Date: null,
            },
            loadingReset: false,
            loadingFind: false,
            loadingRefresh: false,
            settings: {
                shipping: { fees: 0 },
                order: { feesConfirmation: 0, fulfillement_fees: 0, upsell: 0 },
                quality_control: 0,
            },
            amountCurrencySame: [],
            amountExpeditionsCurrencySame: [],
            amountRefundsCurrencySame: [],
            amountChargesCurrencySame: [],
            amountPrimesCurrencySame:[],
            settingsSeller: {
                shipping: { fees: 0 },
                order: { feesConfirmation: 0, fulfillement_fees: 0, upsell: 0 },
                quality_control: 0,
            },
            tva: [],
            settingsFees: {},
            info: { currency: 1, currencyCredit: 1 },
            loadingorderbyseller: false,
            ordersByseller: [],
            tvaPayement: "0",
            transfertFees: 0,
            feesVat: 0,
            confirmation_vat: 0,
            upsell_vat: 0,
            shipping_vat: 0,
            shipping_refund_vat: 0,
            shipping_cancel_vat: 0,
            quality_control: 0,
            fulfillement_fees_vat: 0,
            sellers: [],
            filtersLoad: {},
            filters: {},
            seller: null,
            orders: [],
            totalOrders: [],
            detailsAllorders: [],
            expeditions: [],
            shippings: [],
            charges: [],
            refunds: [],
            selectedRows: [],
            fullPage: false,
            loading: false,
            loadingPay: false,
            loadingShowPay: false,
            sellerSelect: null,
            limit: 10,
            shippingType: 'normal',
            dataType: 'Remboursements',
            totalfeesorder: 0,
            dataCountry: this.$countries,
            warehouses: [],
            cuurency: "",
            warehouse: "",
            servicesSeller: null,
            citiesPrices: [],
            priceCity: 0,
            paginate: {
                total: 0,
                currentpage: 1,
                lastpage: 1,
                per_page: 0,
            },
            headings: [
                {
                    'value': 'Order & Shipping'
                },
                {
                    'value': 'UPSELL fees'
                },
                {
                    'value': 'Confirmation fees'
                },
                {
                    'value': 'Fulfillement fees'
                },
                {
                    'value': 'Shipping fees'
                },
                {
                    'value': 'Return fees'
                },
                {
                    'value': 'Cancelation fees'
                },
            ],
            options: [
                { "name": "transfer", "image": "AF" },
                { "name": "paypal", "image": "AX" },
                { "name": "cash", "image": "AL" },
            ],
            optionsCountries: this.$countries,
            sendEmailData: { loading: 'pending', dataHtml: '', seller: null, data: {} }
        };
    },
    async mounted() {
        this.getwharhouseId();
        await this.getSellers();
        await this.getSettingsPricipal();
        this.getSettings();
        await this.getWarehouses();
        await this.getAllOrdersBySeller({});
    },
    computed: {
        warhouseSelected() {
            return this.$store.getters["wharhouse/warhouseSelected"]({ user: _.pick(this.currentUser, ['countries']) })
        },
    },
    watch: {
        'warhouseSelected': async function (oldVal, newVal) {},
        '$store.state.loadingEmail': async function (oldVal, newVal) {
            this.sendEmailData.loading = oldVal;

            if (this.sendEmailData.loading == 'final') {
                if (this.sendEmailData.seller && this.sendEmailData.seller._id && this.sendEmailData.data.seller && this.sendEmailData.data.seller.toString() == this.formData.seller._id.toString()) {
                    await this.SendEmail(this.sendEmailData);
                }
                await this.PaymentCreate();
            }
        },
        'idWharhouse': async function (oldVal, newVal) {
            this.idWharhouse = oldVal;
            this.getwharhouseId();
            this.filters.seller = this.formData.seller = null; this.orders = [];
            this.intervalDates.from_Date = this.intervalDates.to_Date = this.filters.from_Date = this.filters.to_Date = null;
            if (this.$f.QueryStringToobject()) this.filters = this.$f.QueryStringToobject();
            this.$f.objectToQueryString({ 'country': this.idWharhouse.country,'typeOrder': 'seller' })
            this.filters.country = this.idWharhouse.country;
            this.filters.typeOrder = 'seller';

            await this.getSellers();
            this.getSettings();
            await this.getOrdersBySeller(this.formData.seller, 'seller');
        }
    },
    methods: {
        getCurrencyByCode(country) {
            return this.warehouses.find((e) => e.is_primary && e.country === country).currency;
        },
        async PaymentCreate() {
            this.loadingPay = false;
            this.formData.details = [];
            this.formData.expeditions = [];
            this.formData.infoCurrency = [];
            this.shippings = [];
            this.formData.refunds = []; this.formData.expeditions = []; this.formData.charges = [];this.formData.primes = [];
            this.formData.amountExpeditionsCurrency = []; this.formData.amountChargesCurrency = []; this.formData.amountRefundsCurrency = []; this.formData.amountPrimesCurrency= [];
            this.formData.amountExpeditionsCurrencySame = []; this.formData.amountChargesCurrencySame = []; this.formData.amountRefundsCurrencySame = []; this.formData.amountPrimesCurrencySame=[];
            this.$vm2.close("ModalPay");
            this.sendEmailData = { loading: 'pending', dataHtml: '', seller: null, data: {} };
            this.$store.dispatch("actionloadingemail", { loadingEmail: 'pending' });
            await this.refresh('payement_created');
            alert(this.$t('payement_created'), "success");
        },
        async AddRefunds(name = null, type) {
            if (type) {
                this.$vm2.close("ModalRefunds");

                let columnsRefund = document.querySelectorAll('.rowCheckbox_refund');
                columnsRefund.forEach(column => { column.checked = false });

                let columnsExp = document.querySelectorAll('.rowCheckbox_expedition');
                columnsExp.forEach(column => { column.checked = false });

                let columnsCharge = document.querySelectorAll('.rowCheckbox_charge');
                columnsCharge.forEach(column => { column.checked = false });

                this.TotalAmountOrders();
            } else {
                this.dataType = name;
                await this.getRefunds(name);

                if (name == 'Remboursements') {
                    if (this.refunds.length > 0) {
                        this.$vm2.open("ModalRefunds");
                    } else alert(`Il n'y a aucun remboursement pour ce seller`, "warning");
                }

                if (name == 'Expeditions') {
                    if (this.expeditions.length > 0) {
                        this.$vm2.open("ModalRefunds");
                    } else alert(`Il n'y a aucun Expeditions non payé pour ce seller`, "warning");
                }

                if (name == 'Charges') {
                    if (this.charges.length > 0) {
                        this.$vm2.open("ModalRefunds");
                    } else alert(`Il n'y a aucun Charges non payé pour ce seller`, "warning");
                }
            }
        },
        async getRefunds(name) {
            if (this.formData.seller) {

                if (name == 'Remboursements') {
                    const filters = {
                        seller: this.formData.seller._id || this.formData.seller,
                        country: this.filters.country,
                        status: 'rembourser',
                        isProcessed: false,
                        notPopulate: true,
                        limit: 100
                    };
                    this.loadingPay = true;
                    const res = await this.$server.search("shippings", filters);
                    this.loadingPay = false;
                    if (res.content && res.content.results) {
                        this.refunds = res.content.results;
                    } else this.refunds = [];
                }

                if (name == 'Expeditions') {
                    const filters = {
                        seller: this.formData.seller._id || this.formData.seller,
                        country_to: this.filters.country,
                        status: 'received',
                        isProcessed: false,
                        notPopulate: true,
                        limit: 100
                    };
                    this.loadingPay = true;
                    const res = await this.$server.search("expeditions", filters);
                    this.loadingPay = false;
                    if (res.content && res.content.results) {
                        this.expeditions = res.content.results;
                    } else this.expeditions = [];
                }

                if (name == 'Charges') {
                    const filters = {
                        seller: this.formData.seller._id || this.formData.seller,
                        'warehouse.country': this.filters.country,
                        payment: false,
                        notPopulate: true,
                        limit: 100
                    };
                    this.loadingPay = true;
                    const res = await this.$server.search("charges", filters);
                    this.loadingPay = false;
                    if (res.content && res.content.results) {
                        this.charges = res.content.results;
                    } else this.charges = [];
                }

            } else alert("Seller introuvable ou non sélectionné !!!", "warning");
        },
        getRowDetailRefund($event, itemRef, id, name) {
            if (name == 'Remboursements') {
                let itemInRow = this.formData.refunds.filter(item => item.order.toString() === id.toString());
                let isItemInRow = itemInRow.length > 0;
                if (isItemInRow) {
                    let pos = this.formData.refunds.map(function (e) { return e.order.toString(); }).indexOf(id.toString());
                    this.formData.refunds.splice(pos, 1);
                } else {
                    const dataWarehouse = this.warehouses.find(j => j.country === itemRef.country);
                    this.formData.refunds.push({ order: id, shipping: itemRef._id, orderObjet: itemRef.orderObjet, fees_amount: parseFloat(itemRef.orderObjet.totalPrice), currency: dataWarehouse ? dataWarehouse.currency : this.idWharhouse.currency, country: itemRef.country });
                }
            }

            if (name == 'Expeditions') {
                let itemInRow = this.formData.expeditions.filter(item => item.id.toString() === id.toString());
                let isItemInRow = itemInRow.length > 0;
                if (isItemInRow) {
                    let pos = this.formData.expeditions.map(function (e) { return e.id.toString(); }).indexOf(id.toString());
                    this.formData.expeditions.splice(pos, 1);
                } else {
                    const dataWarehouse = this.warehouses.find(j => j.country === itemRef.country_to);
                    this.formData.expeditions.push({ id: id, fees_amount: parseFloat(itemRef.fees), currency: dataWarehouse ? dataWarehouse.currency : this.idWharhouse.currency, country: itemRef.country_to });
                }
            }

            if (name == 'Charges') {
               // if(itemRef.type === 'credit'){
                    let itemInRow = this.formData.charges.filter(item => item.id.toString() === id.toString());
                    let isItemInRow = itemInRow.length > 0;
                    if (isItemInRow) {
                        let pos = this.formData.charges.map(function (e) { return e.id.toString(); }).indexOf(id.toString());
                        this.formData.charges.splice(pos, 1);
                    } else {
                        const dataWarehouse = this.warehouses.find(j => j.country === itemRef.warehouse.country);
                        this.formData.charges.push({ id: id, fees_amount: parseFloat(itemRef.amount), currency: dataWarehouse ? dataWarehouse.currency : this.idWharhouse.currency, country: itemRef.warehouse.country });
                    }
                // }else{
                //     let itemInRow = this.formData.primes.filter(item => item.id.toString() === id.toString());
                //     let isItemInRow = itemInRow.length > 0;
                //     if (isItemInRow) {
                //         let pos = this.formData.primes.map(function (e) { return e.id.toString(); }).indexOf(id.toString());
                //         this.formData.primes.splice(pos, 1);
                //     } else {
                //         const dataWarehouse = this.warehouses.find(j => j.country === itemRef.warehouse.country);
                //         this.formData.primes.push({ id: id, fees_amount: parseFloat(itemRef.amount), currency: dataWarehouse ? dataWarehouse.currency : this.idWharhouse.currency, country: itemRef.warehouse.country });
                //     }
                // }
               
            }
        },
        async getWarehouses() {
            const filter = { limit: 10 };
            let wares = [];
            const res = await this.$server.search("warehouses", filter);
            if (res && res.content.results) {
                wares = res.content.results;
            } else wares = [];

            for (let i in wares) {
                for (let j in this.currentUser.countries) {
                    if (!this.warehouses.find(o => o.country === wares[i].country) && (wares[i].country === this.currentUser.countries[j].code || this.currentUser.countries[j])) {
                        this.warehouses.push(wares[i]);
                    }
                }
            }
        },
        async getCitiesPrices() {
            const resCities2 = await this.$server.get("zones", { allCitiesAndFees: true, country: await this.warhouseSelected });
            if (resCities2.content.length > 0) {
                for (let i in resCities2.content) {
                    for (let j in resCities2.content[i]._id.cities) {
                        this.citiesPrices.push({ name: resCities2.content[i]._id.cities[j], price: resCities2.content[i]._id.price })
                    }
                }
            } else this.citiesPrices = [];
        },
        async getCurrency() {
            this.warehouse = await this.warhouseSelected
            await this.$store.dispatch('wharhouse/getCurrency').then((res) => {
                this.cuurency = res;
            })
        },
        getwharhouseId() {
            this.formData.warehouses = [];
            this.formData.warehouses.push(this.idWharhouse);
        },
        getElementInArray(data, value) {
            var result = data.filter(function (o) {
                let whar = o.warehouse;
                if (o.warehouse._id) whar = o.warehouse._id;
                return whar == value.toString();
            });
            return result ? result[0] : null; // or undefined
        },
        async getAllOrdersBySeller(filters) {
            if (this.$f.QueryStringToobject()) {
                this.filters = this.$f.QueryStringToobject();
                if (this.filters.from_Date) this.intervalDates = { from_Date: this.filters.from_Date, to_Date: this.filters.to_Date };
                else this.$f.objectToQueryString(_.pick(this.filters, ['country','seller','typeOrder']))
            } else this.$f.objectToQueryString({ 'country': this.idWharhouse.country,'typeOrder':this.formData.typeOrder })

            this.filters = this.$f.QueryStringToobject();
            if (this.intervalDates.from_Date && !Array.isArray(this.intervalDates.from_Date)) {
                this.intervalDates.from_Date = this.intervalDates.from_Date.split(',').map(el => new Date(new Date(el).toString()))
            }
            this.filters.idWharhouse = this.idWharhouse._id;

            if (!this.filters.typeOrder) this.filters.typeOrder = this.formData.typeOrder;

            if (!this.filters.country) this.filters.country = this.idWharhouse.country;
            else {
                if (!filters.changeWarehouse) {
                    this.filters.country.split('-').forEach(function (country) {
                        var index = this.formData.warehouses.findIndex(x => x.country == country);
                        if (index === -1) {
                            const obj = this.warehouses.find(o => o.country === country);
                            this.formData.warehouses.push(obj);
                        }
                    }.bind(this));
                }
            }

            this.filters.settings = this.settings;
            this.filters.warehouses = this.warehouses;
            this.filters.settingsGlobal = this.settingsFees;

            if (this.filters.seller) await this.getOrdersBySeller(this.filters.seller, 'seller')
            else {
                this.loadingorderbyseller = true;
                this.ordersByseller = [];
                const res = await this.$server.getOrdersByseller("orders", this.filters);
                this.loadingorderbyseller = false;
                if (res && Array.isArray(res)) { this.orders = []; this.ordersByseller = res; }
                else {
                    alert(res, "warning");
                    this.ordersByseller = [];
                }
            }

        },
        async getSettingsPricipal() {
            const data = await this.$server.get("settings");
            this.settingsFees = data.content;
        },
        getSettings(seller = null, warehouse = null) {
            const currentSettingW = this.getElementInArray(this.settingsFees.details, warehouse ? warehouse._id : this.idWharhouse._id);

            if (currentSettingW) this.settings = currentSettingW;
            else this.settings = { shipping: { fees: 0 }, order: { feesConfirmation: 0, fulfillement_fees: 0 }, quality_control: 0, info: { mad: 1, currency: 1, currencyCredit: 1 } }
            this.tva = this.settingsFees.tva;
            this.info.currency = this.settings.info.currency;

            if (seller) this.seller = seller;

            if (this.seller) {
                const currentSettingSeller = this.getElementInArray(this.seller.fees, warehouse ? warehouse._id : this.idWharhouse._id);

                //fees confirmation
                if ((currentSettingSeller && currentSettingSeller.confirmation == -1) || !currentSettingSeller) this.confirmation_vat = this.settings.order.feesConfirmation;
                else this.confirmation_vat = currentSettingSeller.confirmation;

                //fees upsell
                if ((currentSettingSeller && typeof currentSettingSeller.upsell === 'number' && currentSettingSeller.upsell == -1) || !currentSettingSeller || (currentSettingSeller && typeof currentSettingSeller.upsell !== 'number')) this.upsell_vat = this.settings.order.upsell;
                else this.upsell_vat = currentSettingSeller.upsell;

                //fees fulfillement
                if ((currentSettingSeller && currentSettingSeller.fulfillement_fees == -1) || !currentSettingSeller) this.fulfillement_fees_vat = this.settings.order.fulfillement_fees;
                else this.fulfillement_fees_vat = currentSettingSeller.fulfillement_fees;

                //fees shipping
                if ((currentSettingSeller && currentSettingSeller.shipping == -1) || !currentSettingSeller) this.shipping_vat = this.settings.shipping.fees;
                else this.shipping_vat = currentSettingSeller.shipping;

                //Cancelation shipping
                if ((currentSettingSeller && currentSettingSeller.cancelation == -1) || !currentSettingSeller) this.shipping_cancel_vat = this.settings.shipping.cancelation;
                else this.shipping_cancel_vat = currentSettingSeller.cancelation;

                //refund shipping
                if ((currentSettingSeller && currentSettingSeller.refund == -1) || !currentSettingSeller) this.shipping_refund_vat = this.settings.shipping.refund;
                else this.shipping_refund_vat = currentSettingSeller.refund;

                //qualite controle
                if ((currentSettingSeller && currentSettingSeller.quality_control == -1) || !currentSettingSeller) this.quality_control = this.settings.quality_control;
                else this.quality_control = currentSettingSeller.quality_control;

                //check seller service
                const services = this.getElementInArray(this.seller.settings, warehouse ? warehouse._id : this.idWharhouse._id);
                if (services && !services.confirmation) { this.confirmation_vat = 0; this.upsell_vat = 0; }
                if (services && !services.fulfillement) this.fulfillement_fees_vat = 0;
                if (services && !services.shipping) { this.shipping_vat = this.shipping_cancel_vat = this.shipping_refund_vat = 0; }
            }
        },
        getImagePay(name) {
            if (name == "cash") return image1;
            else if (name == "paypal") return image2;
            else return image3;
        },
        setSelected(method) {
            if (method) {
                this.formData.method = method.name;
            } else {
                this.formData.method = "cash";
            }
        },
        setTva(tva) {
            let tvafees = 0;
            if (!this.transfertFees) this.transfertFees = 0;
            if (parseFloat(this.transfertFees) != 0) tvafees += parseFloat(this.transfertFees);

            if (tva) {
                if (parseInt(tva) > 0) {
                    this.TotalAmountOrders();
                    tvafees += (this.formData.amount * parseInt(tva)) / 100;
                    this.TotalAmountOrders(tvafees);
                }
            } else {
                this.TotalAmountOrders(tvafees);
                this.tvaPayement = "0";
            }
            this.feesVat = parseFloat(tvafees);
        },
        setTranferfees(event) {
            if (!this.transfertFees) this.transfertFees = 0;
            let fees = parseFloat(this.transfertFees);
            this.TotalAmountOrders();

            if (parseInt(this.tvaPayement) != 0) fees += (this.formData.amount * parseInt(this.tvaPayement)) / 100;
            this.TotalAmountOrders(fees);
        },
        async getOrdersBySeller(seller, type) {
            this.orders = [];
            this.paginate = { total: 0, currentpage: 1, lastpage: 1, per_page: 0, }
            if (seller) {
                if (type == 'seller') {
                    this.loading = true;
                    await this.getSeller(seller._id || seller);
                    this.formData.seller = this.seller;
                    this.filters.seller = this.seller._id;
                    this.ordersByseller = [];
                    const filters = {};
                    const FilterLink = this.$f.QueryStringToobject();
                    if (this.intervalDates.from_Date && FilterLink.from_Date) {
                        filters.from_Date = FilterLink.from_Date;
                        filters.to_Date = this.filters.to_Date;
                    }
                    this.$f.objectToQueryString(_.pick(this.filters, ['country', 'seller', 'from_Date','typeOrder'])) 

                    if (this.filters.country) filters.country = this.filters.country;
                    if (this.filters.typeOrder) filters.typeOrder = this.filters.typeOrder;

                    this.sellerSelect = this.seller._id.toString();
                    this.loadingShowPay = true;
                    this.getSettings();
                    console.time('order1')
                    await this.getTotalOrders();
                    console.timeEnd('order1')
                    await this.getOrders(filters);
                    if (this.formData.warehouses.length == 1) await this.getExpedition(filters);
                    this.getSettings();
                    this.loading = false;
                    this.loadingShowPay = false;
                } else {
                    if (this.formData.warehouses.length == 0) this.formData.warehouses.push(this.idWharhouse)
                    this.filters.country = this.formData.warehouses.map(e => e.country).join('-');
                    this.filters.typeOrder= this.formData.typeOrder;
                    this.$f.objectToQueryString(_.pick(this.filters, ['country', 'seller', 'from_Date','typeOrder']))
                    this.orders = this.ordersByseller = [];
                    await this.getAllOrdersBySeller({});
                }

            } else {
                if (type == 'seller') {
                    this.sellerSelect = this.filters.seller = this.formData.seller = this.seller = null;
                    this.$f.objectToQueryString(_.pick(this.filters, ['country', 'from_Date','typeOrder']));
                    await this.getAllOrdersBySeller({});
                }
            }
        },
        async refresh(type = null) {
            if (type) { this.sellerSelect = this.filters.seller = this.formData.seller = this.seller = null; }
            this.$f.objectToQueryString(_.pick(this.filters, ['country', 'from_Date','typeOrder']))
            await this.getAllOrdersBySeller({});

        },
        async getStatusByName(name) {
            const result = await this.$server.get("status", { name: name });
            return result.content._id;
        },
        async getOrders(filter) {
            const FilterLink = this.$f.QueryStringToobject();
            if (this.intervalDates.from_Date && FilterLink.from_Date) {
                filter.from_Date = FilterLink.from_Date;
                filter.to_Date = this.intervalDates.to_Date;
            }
            filter.seller = this.formData.seller._id;
            filter.limit = this.limit;
            if (!this.filters.country) filter["country"] = await this.warhouseSelected;
            filter.status = 'PaidOrRefunded';
            filter.page = this.paginate.currentpage++;
            this.headings = [
                {
                    'value': 'Order & Shipping'
                },
                {
                    'value': 'UPSELL fees'
                },
                {
                    'value': 'Confirmation fees'
                },
                {
                    'value': 'Fulfillement fees'
                },
                {
                    'value': 'Shipping fees'
                },
                {
                    'value': 'Return fees'
                },
                {
                    'value': 'Cancelation fees'
                },

            ];

            const res = await this.$server.search("shippings", _.pick(filter, ['country', 'seller', 'status', 'page', 'limit', 'from_Date','typeOrder']));
            if (res && res.content.results && !res.content.error) {
                for (let i in res.content.results) {
                    this.orders.push(res.content.results[i])
                }
                this.paginate.total = res.content.total;
                this.paginate.lastpage = res.content.last_page;
                this.paginate.per_page = res.content.per_page;
                this.paginate.currentpage = res.content.current_page;
                this.orders = this.orders.sort((a, b) => b.country - a.country);
                this.orders.forEach(e => { if (e.status == 'return') e.order.totalPrice = 0; });

            } else {
                this.orders = []; this.paginate.lastpage = 1;
                if (res && res.content.error) alert(res.content.error, "warning");
            };
        },
        totalorderFees(warehouse, order, data, conf_fees, fulfillement_fees, shipping_fees, shipping_refund_fees, shipping_cancel_fees, quality_control_fees, upsell_fees) {
            let totalfees = 0;
            let returnfees = 0; let cancell_fess = 0;
            const services = this.getElementInArray(order.seller.settings, warehouse._id);
            if (order.status == "return") shipping_fees = 0;
            if (order.status == "return" && order.isRefunded && services && services.shipping) returnfees = shipping_refund_fees;
            if (order.status == "return" && order.isCancelled && services && services.shipping) cancell_fess = shipping_cancel_fees;
            if((order.affiliate && order.affiliate.type) || (order.POD && order.POD.name)) {
                conf_fees = fulfillement_fees = shipping_fees = returnfees = cancell_fess = quality_control_fees = upsell_fees=0;
            }
            totalfees += conf_fees + fulfillement_fees + shipping_fees + returnfees + cancell_fess + quality_control_fees;

            //check upsel Order
            let quantity_appseller = 0;
            const upselOrder = order.order.upsel ? JSON.parse(order.order.upsel) : false;
            if (upselOrder) quantity_appseller = order.order.quantity_appseller || 0;
            else upsell_fees = 0;
            totalfees += upsell_fees * quantity_appseller;

            data.push({
                currency: warehouse.currency,
                country: order.country,
                totalPrice: order.order.totalPrice,
                orderObjet: order.orderObjet,
                order: order.order._id,
                shipping: order._id,
                courier: order.courier ? order.courier._id || order.courier : null,
                amount: this.getAmountByAction(order,totalfees),
                confirmation_vat: conf_fees,
                fulfillement_fees_vat: fulfillement_fees,
                shipping_vat: shipping_fees,
                shipping_refund_vat: returnfees,
                shipping_cancel_vat: cancell_fess,
                quality_control: quality_control_fees,
                quantity_appseller: quantity_appseller,
                upsel: upselOrder,
                upsell_vat: upsell_fees * quantity_appseller,
                affiliate: order.affiliate && order.affiliate.type?{ type:"affiliate",commission:order.affiliate.commission}:{},
            });

        },
        getAmountByAction(data,totalfees){
            let amount=0;
            if(data.affiliate && data.affiliate.type) amount= data.affiliate.commission;
            else if(data.POD && data.POD.name) amount= data.POD.commission;
            else amount= data.order.totalPrice - totalfees
            return amount;
        },
        getPriceBycity(city, array) {
            let price = 0;
            for (var i = 0; i < array.length; i++) {
                if ((array[i].name).toLowerCase() === city.toLowerCase()) {
                    price = array[i].price;
                    break;
                }
            }
            return price;
        },
        async getTotalOrders(seller = null) {
            let filter = {};
            if (seller) this.getSettings(seller);
            filter.seller = seller ? seller._id : this.formData.seller._id;
            filter.limit = 10000;
            filter['country'] = await this.warhouseSelected;
            if (this.filters.country) filter['country'] = this.filters.country;
            if (this.filters.typeOrder) filter['typeOrder'] = this.filters.typeOrder;
            
            
            const FilterLink = this.$f.QueryStringToobject();
            if (this.intervalDates.from_Date && FilterLink.from_Date) {
                filter.from_Date = FilterLink.from_Date;
                filter.to_Date = this.intervalDates.to_Date;
            }
            filter.status = 'PaidOrRefunded';
            this.$insProgress.start();
            const res = await this.$server.search("shippings", filter);
            this.detailsAllorders = []; this.formData.details = [];
            if (res && res.content.results && !res.content.error) {
                this.totalOrders = res.content.results;
                for (let i in this.totalOrders) {
                    const dataWarehouse = this.warehouses.find(item => item.country === this.totalOrders[i].country);
                    this.getSettings(this.totalOrders[i].seller, dataWarehouse ? dataWarehouse : this.idWharhouse);
                    if (this.totalOrders[i].status == 'return') {
                        this.totalOrders[i].order.totalPrice = 0;
                    }
                    const services = this.getElementInArray(this.totalOrders[i].seller.settings, this.idWharhouse._id);
                    if (this.totalOrders[i].country == "MA" && services && services.shipping && this.totalOrders[i].order.customer.city) {
                        this.shipping_vat = this.getPriceBycity(this.totalOrders[i].order.customer.city, this.citiesPrices)
                    }
                    this.totalorderFees(dataWarehouse ? dataWarehouse : this.idWharhouse, this.totalOrders[i], this.detailsAllorders, this.confirmation_vat, this.fulfillement_fees_vat, this.shipping_vat, this.shipping_refund_vat, this.shipping_cancel_vat, this.quality_control, this.upsell_vat)
                }
            } else {
                this.totalOrders = [];
                this.loadingShowPay = false;
                if (res && res.content.error) alert(res.content.error, "warning");
            }
            this.$insProgress.finish()
        },
        totalOrdersAmountFees() {
            let amount = 0; let fees = 0; let amountArray = []; let feesArray = []
            let groupByCurrency = _.groupBy(this.detailsAllorders, function (n) { return n.country; });
            groupByCurrency = Object.entries(groupByCurrency).map((obj) => ({
                currency: this.warehouses.find(item => item.country === obj[0]).currency,
                country: obj[0],
                data: obj[1],
                count: obj[1].length,
                totalPrice: obj[1].map(item => item.affiliate && item.affiliate.type?item.affiliate.commission:item.POD && item.POD.name?item.POD.commission:item.totalPrice).reduce((prev, next) => prev + next),
                amount: obj[1].map(item => item.amount).reduce((prev, next) => prev + next),
                fees: obj[1].map(item => item.confirmation_vat + item.fulfillement_fees_vat + item.shipping_cancel_vat + item.shipping_refund_vat + item.shipping_vat + (item.quality_control || 0) + (item.upsell_vat || 0)).reduce((prev, next) => prev + next)
            }));
            return { dataArray: groupByCurrency, amount: amount, fees: fees, count: this.detailsAllorders.length };
        },
        totalfeesorderF(item) {
            this.totalfeesorder = item.confirmation_vat + item.fulfillement_fees_vat + item.shipping_vat + item.shipping_refund_vat + item.shipping_cancel_vat + item.quality_control;
        },
        async getShippingsType(id) {
            const filters = {};
            filters.order = id;
            filters.status = 'paid';
            const res = await this.$server.search("shippings", filters);
            if (res.content.results) {
                this.shippingType = res.content.results[0].type;
            };
            return this.shippingType;
        },
        async getExpedition(filterExp) {
            if (!filterExp.country) filterExp["country"] = await this.warhouseSelected;
            filterExp.seller = this.formData.seller._id;
            filterExp.status = 'received';
            filterExp.limit = 10;
            filterExp.paid = false;
            const res = await this.$server.search("expeditions", _.pick(filterExp, ['paid', 'limit', 'status', 'seller', 'country']));
            if (res.content.results) {
                this.expeditions = res.content.results;
            } else this.expeditions = [];
        },
        async getShippings(filter) {
            const res = await this.$server.search("shippings", filter);
            if (res.content.results) {
                this.shippings = res.content.results;
            } else this.shippings = [];
        },
        selectAllCheckbox($event) {
            let columns = document.querySelectorAll('.rowCheckbox');

            this.formData.details = [];

            if ($event.target.checked == true) {
                columns.forEach(column => {
                    column.checked = true;

                    let order = this.orders.filter(item => item.order._id.toString() === column.id.toString());
                    const dataWarehouse = this.warehouses.find(j => j.country === order[0].country);
                    //check upsel Order
                    let quantity_appseller = 0;
                    const upselOrder = order[0].order.upsel ? JSON.parse(order[0].order.upsel) : false;
                    if (upselOrder) quantity_appseller = order[0].order.quantity_appseller || 0;

                    const data = {
                        order: column.id,
                        country: order[0].country,
                        currency: dataWarehouse ? dataWarehouse.currency : this.idWharhouse.currency,
                        totalPrice: order[0].order.totalPrice,
                        shipping: order[0]._id,
                        courier: order[0].courier ? order[0].courier._id || order[0].courier : null,
                        orderObjet: order[0].orderObjet,
                        confirmation_vat: parseInt(order[0].order.confirmation_vat),
                        fulfillement_fees_vat: parseInt(order[0].order.fulfillement_fees_vat),
                        shipping_vat: parseInt(order[0].order.shipping_vat),
                        shipping_refund_vat: parseInt(order[0].order.shipping_refund_vat),
                        shipping_cancel_vat: parseInt(order[0].order.shipping_cancel_vat),
                        quality_control: parseInt(order[0].order.quality_control),
                        quantity_appseller: quantity_appseller,
                        upsel: upselOrder,
                        upsell_vat: upselOrder ? (parseInt(order[0].order.upsell_vat) * quantity_appseller) : 0,
                        affiliate: order[0].affiliate && order[0].affiliate.type?{ type:"affiliate",commission:order[0].affiliate.commission }:{},
                        amount: order[0].affiliate && order[0].affiliate.type?order[0].affiliate.commission:order[0].POD && order[0].POD.name?order[0].POD.commission:this.TotalAmont(order[0].order.totalPrice, order[0].order.confirmation_vat, order[0].order.fulfillement_fees_vat, order[0].order.shipping_vat, order[0].order.shipping_refund_vat, order[0].order.shipping_cancel_vat, order[0].order.quality_control, order[0].order.upsell_vat, upselOrder, quantity_appseller)
                    };
                    this.formData.details.push(data);
                });
            } else {
                columns.forEach(column => {
                    column.checked = false
                });
                let columnsExp = document.querySelectorAll('.checkbox-exp');
                columnsExp.forEach(column => {
                    column.checked = false
                });
                this.formData.details = [];
                this.formData.expeditions = [];
            }
            this.TotalAmountOrders();
        },
        TotalAmont: function (total, conf_fees, ful_fees, shipp_fees, refound_fees, chang_fees, quality_control, upsel_fees, upsell, qteUpsell) {
            let totalA = parseFloat(total) - (parseFloat(conf_fees) + parseFloat(ful_fees) + parseFloat(shipp_fees) + parseFloat(refound_fees) + parseFloat(chang_fees) + parseFloat(quality_control));
            if (upsell) totalA = totalA - (upsel_fees * qteUpsell)

            return totalA;
        },
        sumObjAmountCurrency(isTotalData=false,objArr, refunds = [], expeditions = [], charges = [],primes=[]) {
            var newArr = [];

            if(isTotalData){
                this.formData.warehouses.forEach(row2 => {
                    var index = objArr.findIndex(x => x.currency == row2.currency);
                    if (index === -1) objArr.push({
                        "count": 0,
                        "currency": row2.currency,
                        "country": row2.country,
                        "totalPrice": 0,
                        "amount": 0,
                        "fees": 0
                    })
                });
                console.log('objArr---------',objArr)
            }

            primes.forEach(row => { row.type = 'primes'; });

            if (refunds.length > 0) objArr = objArr.concat(refunds);
            if (expeditions.length > 0) objArr = objArr.concat(expeditions);
            if (charges.length > 0) objArr = objArr.concat(charges);
            if (primes.length > 0) objArr = objArr.concat(primes);


          //  console.log('objArr---------',objArr)

            //methode 2
            newArr = objArr.reduce((acc, curr) => {
                let item = acc.find(item => item.currency === curr.currency);
             //   console.log('item currency---------',item,curr.currency)
                if (item) {
                    if (!item.amount) item.amount = 0; if (!curr.amount) curr.amount = 0;
                    if (!item.count) item.count = 0; if (!curr.count) curr.count = 0;
                    if (!item.fees) item.fees = 0; if (!curr.fees) curr.fees = 0;
                    if (!item.totalPrice) item.totalPrice = 0; if (!curr.totalPrice) curr.totalPrice = 0;
                    if (!item.fees_amount) item.fees_amount = 0; if (!curr.fees_amount) curr.fees_amount = 0;

                    if (!item.amount1) item.amount1 = 0; if (!curr.amount1) curr.amount1 = 0;
                    if (!item.count1) item.count1 = 0; if (!curr.count1) curr.count1 = 0;
                    if (!item.fees1) item.fees1 = 0; if (!curr.fees1) curr.fees1 = 0;
                    if (!item.totalPrice1) item.totalPrice1 = 0; if (!curr.totalPrice1) curr.totalPrice1 = 0;
                    if (!item.fees_amount1) item.fees_amount1 = 0; if (!curr.fees_amount1) curr.fees_amount1 = 0;


                    item.amount += curr.amount1 || curr.amount;
                    item.count += curr.count1 || curr.count;
                    item.fees += curr.fees1 || curr.fees;
                    item.totalPrice += curr.totalPrice1 || curr.totalPrice;

                    if(!curr.type) item.amount -= curr.fees_amount1 || curr.fees_amount;
                    else item.amount += curr.fees_amount1 || curr.fees_amount;

                } else {
                    if (!curr.amount) curr.amount = 0;
                    if (!curr.count) curr.count = 0;
                    if (!curr.fees) curr.fees = 0;
                    if (!curr.totalPrice) curr.totalPrice = 0;
                    if (!curr.fees_amount) curr.fees_amount = 0;
                    acc.push(curr);
                }

                return acc;
            }, []);
            //method 3
            const datas = {};

            return newArr;
        },
        TotalAmountOrders(tva_tarnsFees = null) {
            this.formData.amount = 0; this.formData.amountCurrency = []; this.formData.amountRefundsCurrency = []; this.formData.amountChargesCurrency = []; this.formData.amountExpeditionsCurrency = [];
            this.amountCurrencySame = []; this.amountChargesCurrencySame = []; this.amountExpeditionsCurrencySame = []; this.amountPrimesCurrencySame = [];  this.formData.amountPrimesCurrency=[];

            // Orders
            let groupByCurrency = _.groupBy(this.formData.details, function (n) { return n.country; });
            groupByCurrency = Object.entries(groupByCurrency).map((obj) => ({
                count1: obj[1].length,
                currency1: this.warehouses.find(item => item.country === obj[0]).currency,
                country1: obj[0],
                data1: obj[1],
                totalPrice1: obj[1].map(item => item.affiliate && item.affiliate.type?item.affiliate.commission:item.POD && item.POD.name?item.POD.commission:item.totalPrice).reduce((prev, next) => prev + next),
                amount1: obj[1].map(item => item.amount).reduce((prev, next) => prev + next),
                fees1: obj[1].map(item => item.confirmation_vat + item.fulfillement_fees_vat + item.shipping_cancel_vat + item.shipping_refund_vat + item.shipping_vat + (item.quality_control || 0) + (item.upsell_vat || 0)).reduce((prev, next) => prev + next)
            }));
            let newArray = [];
            groupByCurrency.forEach(function (ele) {
                ele = JSON.stringify(ele); // parse
                ele = JSON.parse(ele); // 
                ele.count = ele.count1;
                ele.currency = ele.currency1;
                ele.country = ele.country1;
                ele.data = ele.data1;
                ele.totalPrice = ele.totalPrice1;
                ele.amount = ele.amount1;
                ele.fees = ele.fees1;
                newArray.push(ele)
            });

            this.formData.amountCurrency = newArray

            if (this.formData.amountCurrency.length > 0) this.formData.amount += this.formData.amountCurrency.map(item => item.amount1).reduce((prev, next) => prev + next);
            // Orders

            // Refunds
            let groupByRefundsCurrency = _.groupBy(this.formData.refunds, function (n) { return n.country; });
            groupByRefundsCurrency = Object.entries(groupByRefundsCurrency).map((obj) => ({
                count1: obj[1].length,
                currency1: this.warehouses.find(item => item.country === obj[0]).currency,
                country1: obj[0],
                data1: obj[1],
                fees_amount1: obj[1].map(item => item.fees_amount).reduce((prev, next) => prev + next),
            }));

            let newArrayRefunds = [];
            groupByRefundsCurrency.forEach(function (ele) {
                ele = JSON.stringify(ele); // parse
                ele = JSON.parse(ele); // 
                ele.count = ele.count1;
                ele.currency = ele.currency1;
                ele.country = ele.country1;
                ele.data = ele.data1;
                ele.fees_amount = ele.fees_amount1;
                newArrayRefunds.push(ele)
            });

            this.formData.amountRefundsCurrency = newArrayRefunds
            // Refunds


            // Expeditions 
            let groupByExpeditionsCurrency = _.groupBy(this.formData.expeditions, function (n) { return n.country; });
            groupByExpeditionsCurrency = Object.entries(groupByExpeditionsCurrency).map((obj) => ({
                count1: obj[1].length,
                currency1: this.warehouses.find(item => item.country === obj[0]).currency,
                country1: obj[0],
                data1: obj[1],
                fees_amount1: obj[1].map(item => item.fees_amount).reduce((prev, next) => prev + next),
            }));
            let newArrayExpeditions = [];
            groupByExpeditionsCurrency.forEach(function (ele) {
                ele = JSON.stringify(ele); // parse
                ele = JSON.parse(ele); // 
                ele.count = ele.count1;
                ele.currency = ele.currency1;
                ele.country = ele.country1;
                ele.data = ele.data1;
                ele.fees_amount = ele.fees_amount1;
                newArrayExpeditions.push(ele)
            });

            this.formData.amountExpeditionsCurrency = newArrayExpeditions;
            // Refunds


            // Charges
            let groupByChargesCurrency = _.groupBy(this.formData.charges, function (n) { return n.country; });
            groupByChargesCurrency = Object.entries(groupByChargesCurrency).map((obj) => ({
                count1: obj[1].length,
                currency1: this.warehouses.find(item => item.country === obj[0]).currency,
                country1: obj[0],
                data1: obj[1],
                fees_amount1: obj[1].map(item => item.fees_amount).reduce((prev, next) => prev + next),
            }));
            let newArrayCharges = [];
            groupByChargesCurrency.forEach(function (ele) {
                ele = JSON.stringify(ele); // parse
                ele = JSON.parse(ele); // 
                ele.count = ele.count1;
                ele.currency = ele.currency1;
                ele.country = ele.country1;
                ele.data = ele.data1;
                ele.fees_amount = ele.fees_amount1;
                newArrayCharges.push(ele)
            });

            this.formData.amountChargesCurrency = newArrayCharges;



             // Charges Primes
             let groupByPrimesCurrency = _.groupBy(this.formData.primes, function (n) { return n.country; });
             groupByPrimesCurrency = Object.entries(groupByPrimesCurrency).map((obj) => ({
                count1: obj[1].length,
                currency1: this.warehouses.find(item => item.country === obj[0]).currency,
                country1: obj[0],
                data1: obj[1],
                fees_amount1: obj[1].map(item => item.fees_amount).reduce((prev, next) => prev + next),
            }));
            let newArrayPrimes = [];
            groupByPrimesCurrency.forEach(function (ele) {
                ele = JSON.stringify(ele); // parse
                ele = JSON.parse(ele); // 
                ele.count = ele.count1;
                ele.currency = ele.currency1;
                ele.country = ele.country1;
                ele.data = ele.data1;
                ele.fees_amount = ele.fees_amount1;
                newArrayPrimes.push(ele)
            });

            this.formData.amountPrimesCurrency = newArrayPrimes;

            if (parseFloat(tva_tarnsFees) > 0) this.formData.amount -= tva_tarnsFees;

            //refunds
            this.amountRefundsCurrencySame = this.sumObjAmountCurrency(false,this.formData.amountRefundsCurrency);
            this.formData.amountRefundsCurrencySame = this.amountRefundsCurrencySame;

            //expeditions
            this.amountExpeditionsCurrencySame = this.sumObjAmountCurrency(false,this.formData.amountExpeditionsCurrency);
            this.formData.amountExpeditionsCurrencySame = this.amountExpeditionsCurrencySame;

            //charges
            this.amountChargesCurrencySame = this.sumObjAmountCurrency(false,this.formData.amountChargesCurrency);
            this.formData.amountChargesCurrencySame = this.amountChargesCurrencySame;

            //charges primes
            this.amountPrimesCurrencySame = this.sumObjAmountCurrency(false,this.formData.amountPrimesCurrency);
            this.formData.amountPrimesCurrencySame = this.amountPrimesCurrencySame;


            this.amountCurrencySame = this.sumObjAmountCurrency(true,this.formData.amountCurrency, this.formData.amountRefundsCurrency, this.formData.amountExpeditionsCurrency, this.formData.amountChargesCurrency,this.formData.amountPrimesCurrency);
            this.formData.amountCurrencySame = this.amountCurrencySame;
        },
        TotalFees() {
            var confirmation_vat = 0;
            var fulfillement_fees_vat = 0;
            var shipping_vat = 0;
            var shipping_refund_vat = 0;
            var shipping_cancel_vat = 0;
            var quality_control = 0;
            var upsell_vat = 0;
            for (let i in this.formData.details) {
                confirmation_vat += this.formData.details[i].confirmation_vat;
                fulfillement_fees_vat += this.formData.details[i].fulfillement_fees_vat;
                shipping_vat += this.formData.details[i].shipping_vat;
                shipping_refund_vat += this.formData.details[i].shipping_refund_vat;
                shipping_cancel_vat += this.formData.details[i].shipping_cancel_vat;
                quality_control += this.formData.details[i].quality_control;
            }
            return confirmation_vat + fulfillement_fees_vat + shipping_vat + shipping_refund_vat + shipping_cancel_vat + quality_control;
        },
        UpdateRowFees(order, data1, data2, data3, data4, data5, data6, data7, amount) {
            this.formData.details.filter(item => {
                if (item.order.toString() === order._id.toString()) {
                    item.confirmation_vat = parseInt(data1);
                    item.fulfillement_fees_vat = parseInt(data2);
                    item.shipping_vat = parseInt(data3);
                    item.shipping_refund_vat = parseInt(data4);
                    item.shipping_cancel_vat = parseInt(data5);
                    item.quality_control = parseInt(data6);
                    item.upsell_vat = parseInt(data7);
                    item.amount = amount;
                }
            });
            this.TotalAmountOrders();
        },
        getRowDetailExp($event, itemExp, id) {
            let itemInRow = this.formData.expeditions.filter(item => item.id === id);
            let isItemInRow = itemInRow.length > 0;
            if (isItemInRow) {
                let pos = this.formData.expeditions.map(function (e) {
                    return e.id;
                }).indexOf(id);
                this.formData.expeditions.splice(pos, 1);
            } else {
                const data = {
                    id: id,
                    fees: parseInt(itemExp.fees),
                };
                this.formData.expeditions.push(data);
            }
            this.TotalAmountOrders();
        },
        getRowDetail($event, item, id) {
            let itemInRow = this.formData.details.filter(item => item.order === id);
            let isItemInRow = itemInRow.length > 0;

            if (isItemInRow) {
                let pos = this.formData.details.map(function (e) { return e.order; }).indexOf(id);
                this.formData.details.splice(pos, 1);
            } else {
                const dataWarehouse = this.warehouses.find(j => j.country === item.country);
                //check upsel Order
                let quantity_appseller = 0;
                const upselOrder = item.order.upsel ? JSON.parse(item.order.upsel) : false;
                if (upselOrder) quantity_appseller = item.order.quantity_appseller || 0;

                const data = {
                    order: id,
                    country: item.country,
                    currency: dataWarehouse ? dataWarehouse.currency : this.idWharhouse.currency,
                    totalPrice: item.order.totalPrice,
                    shipping: item._id,
                    courier: item.courier ? item.courier._id || item.courier : null,
                    orderObjet: item.orderObjet,
                    confirmation_vat: parseInt(item.order.confirmation_vat),
                    fulfillement_fees_vat: parseInt(item.order.fulfillement_fees_vat),
                    shipping_vat: parseInt(item.order.shipping_vat),
                    shipping_refund_vat: parseInt(item.order.shipping_refund_vat),
                    shipping_cancel_vat: parseInt(item.order.shipping_cancel_vat),
                    quality_control: parseInt(item.order.quality_control),
                    quantity_appseller: quantity_appseller,
                    upsel: upselOrder,
                    upsell_vat: upselOrder ? (parseInt(item.order.upsell_vat) * quantity_appseller) : 0,
                    affiliate: item.affiliate && item.affiliate.type?{ type:"affiliate",commission:item.affiliate.commission }:{},
                    amount: item.affiliate && item.affiliate.type?item.affiliate.commission:item.POD && item.POD.name?item.POD.commission:this.TotalAmont(item.order.totalPrice, item.order.confirmation_vat, item.order.fulfillement_fees_vat, item.order.shipping_vat, item.order.shipping_refund_vat, item.order.shipping_cancel_vat, item.order.quality_control, item.order.upsell_vat, upselOrder, quantity_appseller)
                };
                this.formData.details.push(data);
            }
            if (this.formData.details.length === 0) {
                let columns = document.querySelectorAll('.checkallbbox');
                columns.forEach(column => { column.checked = false });
                let columnsExp = document.querySelectorAll('.checkbox-exp');
                columnsExp.forEach(column => { column.checked = false });
                this.formData.expeditions = [];
            }
            this.TotalAmountOrders();
        },
        async getSellers() {
            const filter = {
                type: "Seller",
                countries: await this.warhouseSelected,
                limit: this.limit,
            };
            const res = await this.$server.search("users", filter);
            if (res.content.results) this.sellers = res.content.results;
            else this.sellers = [];
        },
        searchSellers: _.debounce(async function (search) {
            const filter = {
                type: "Seller",
                countries: await this.warhouseSelected,
                limit: this.limit,
                name: search,
            };
            const res = await this.$server.find("users", filter);

            if (res.content.results) this.sellers = res.content.results;
            else this.sellers = [];
        }, 500),
        async getSeller(id) {
            const filter = {
                _id: id,
            };
            const res = await this.$server.search("users", filter);
            if (res.content.results) this.seller = res.content.results[0];
            else this.seller = null;
        },
        async save() {
            let modal_id = "ModalPay";
            if (this.formData.details.length > 0) {

                this.$confirm(this.$t('you_sure')).then(async (res) => {
                    if (res) {
                        this.loadingPay = true;
                        this.$insProgress.start()

                        this.formData.country = await this.warhouseSelected;
                        this.formData.count = this.formData.details.length;
                        this.formData.info.currency = this.info.currency;
                        this.formData.info.confirmation_vat = this.confirmation_vat;
                        this.formData.info.upsell_vat = this.upsell_vat;
                        this.formData.info.shipping_vat = this.shipping_vat;

                        this.formData.warehouses.forEach(war => {
                            if (!this.formData.infoCurrency.find(o => o.country === war.country)) {
                                let info = { mad: 1, currency: 1, currencyCredit: 1, currencyUSD:1, currencyUSDCredit:1 };
                                const currentSettingW = this.getElementInArray(this.settingsFees.details, war._id);
                                if (currentSettingW) info = currentSettingW.info;
                                this.formData.infoCurrency.push({ currency: info.currency, currencyCredit: info.currencyCredit,currencyUSD: info.currency, currencyUSDCredit: info.currencyCredit, country: war.country, currencyName: war.currency, confirmation_vat: 0, shipping_vat: 0, upsell_vat: 0 });
                            }
                        });
                        this.formData.infoCurrency.forEach(info => {
                            const dataCountry = this.formData.details.find(j => j.country === info.country);
                            if (dataCountry) {
                                info.confirmation_vat = dataCountry.confirmation_vat;
                                info.upsell_vat = dataCountry.upsell_vat;
                                info.shipping_vat = dataCountry.shipping_vat;
                            }
                        });
                        const FilterLink = this.$f.QueryStringToobject();
                        if (this.intervalDates.from_Date && FilterLink.from_Date) {
                            if (FilterLink.from_Date.split(',').length != 2) {
                                alert('Error Range date, please actulisé la page', "error");
                                this.loadingPay = false;
                                this.$insProgress.finish()
                            }
                            this.formData.intervalDate = { fromDate: new Date(FilterLink.from_Date.split(',')[0]), toDate: new Date(FilterLink.from_Date.split(',')[1]) }
                        }

                        const data = await this.$server.create("payments", this.formData);
                        this.loadingPay = false;
                        this.$insProgress.finish()
                        if (data && data._id) {
                            //send email to seller
                            this.sendEmailData.data = data;
                            this.sendEmailData.seller = this.formData.seller;

                        } else alert(data.content ? data.content.error || data.content : data, "warning");
                    }
                });

            } else {
                alert(this.$t('no_order_selected'), "warning");
            }
        },
        async getUser() {
            const res = await this.$server.me("users");
            if (res.content) this.currentUser = res.content;
            else this.currentUser = {};
        },

        async OpenClosePopPayMethode(action, type = null, seller = null) {
            let modal_id = "ModalPay";
            if (type === 'allOrders') this.loadingShowPay = true;
            if (['Remboursements', 'Expeditions', 'Charges'].indexOf(type) != -1) modal_id = 'ModalRefunds';

            if (seller) {
                this.sellerSelect = seller._id.toString();
                await this.getTotalOrders(seller);
            } else this.sellerSelect = null;

            if (type === 'allOrders') {

                this.formData.details = []; this.formData.amount = 0;
                this.formData.refunds = []; this.formData.expeditions = []; this.formData.charges = []; this.formData.primes = [];
                this.formData.amountExpeditionsCurrency = []; this.formData.amountChargesCurrency = []; this.formData.amountRefundsCurrency = []; this.formData.amountPrimesCurrency=[]
                this.formData.amountExpeditionsCurrencySame = []; this.formData.amountChargesCurrencySame = []; this.formData.amountRefundsCurrencySame = [];
                this.formData.details = this.detailsAllorders;
                if (seller) this.formData.seller = seller;

                this.formData.amount = this.totalOrdersAmountFees().dataArray.map(item => item.amount).reduce((prev, next) => prev + next);
                this.formData.amountCurrency = this.totalOrdersAmountFees().dataArray;
                this.formData.amountCurrencySame = this.sumObjAmountCurrency(false,this.totalOrdersAmountFees().dataArray);
                this.loadingShowPay = false;

            }

            if (action === 'open') {
                if (this.formData.details.length > 0) {
                    this.$vm2.open(modal_id)
                } else alert(this.$t('no_order_selected'), "warning");
            } else {
                if (type) {
                    this.$confirm(`Tous les ${type} sélectionner sera supprimé dans ce payment`).then(async (action) => {
                        if (action) {
                            if (type == 'Remboursements') {
                                this.formData.refunds = [];
                                let columns = document.querySelectorAll('.rowCheckbox_refund');
                                columns.forEach(column => { column.checked = false });
                                this.TotalAmountOrders();
                            } else if (type == 'Expeditions') {
                                this.formData.expeditions = [];
                                let columns = document.querySelectorAll('.rowCheckbox_expedition');
                                columns.forEach(column => { column.checked = false });
                                this.TotalAmountOrders();
                            } else if (type == 'Charges') {
                                this.formData.charges = [];
                                this.formData.primes = [];
                                let columns = document.querySelectorAll('.rowCheckbox_charge');
                                columns.forEach(column => { column.checked = false });
                                this.TotalAmountOrders();
                            }
                            this.$vm2.close(modal_id);
                        }
                    });
                } else {
                    this.formData.details = []; this.formData.amount = 0;
                    this.$vm2.close(modal_id);
                }
            }
        },
        async loadMore() {
            var page = 0;
            page = ++this.paginate.currentpage;
            this.filters.page = page;
            this.filters.limit = this.limit;
            this.getOrders(this.filters);
        },
        async FindOrderByBetweenDate() {
            this.loadingFind = true;
            const filters = {};
            this.paginate.currentpage = 1;

            this.orders = this.ordersByseller = [];
            this.filters.seller = this.formData.seller = this.filters.seller = null;
            if (this.intervalDates.from_Date) {
                this.filters.from_Date = this.intervalDates.from_Date.map(el => this.$moment(el).format('yyyy-MM-DD'));
                this.filters.to_Date = this.intervalDates.to_Date;
            } else {
                alert('Please select date !!!', "warning");
                this.loadingFind = false;
                return false;
            }

            this.$f.objectToQueryString(_.pick(this.filters, ['country', 'from_Date','typeOrder']));

            await this.getAllOrdersBySeller({});
            this.loadingFind = false;
        },
        async reset() {
            this.paginate.currentpage = 1;
            this.intervalDates.from_Date = this.intervalDates.to_Date = this.filters.from_Date = this.filters.to_Date = null;

            this.filters.seller = this.formData.seller = null; this.orders = [];
            this.$f.objectToQueryString(_.pick(this.filters, ['country','typeOrder']))
            await this.getAllOrdersBySeller({});
        },
        async paginatation(direction) {
            var page = 0;
            if (direction == "next") {
                page = ++this.paginate.currentpage;
            } else {
                page = --this.paginate.currentpage;
            }

            this.filters.page = page;
            this.filters.limit = this.limit;
            this.getOrders(this.filters);
        },

        async SendEmail(data) {
            this.sendEmailData.dataHtml = '';
            this.sendEmailData.dataHtml += `<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Transitional//EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd"><html xmlns="http://www.w3.org/1999/xhtml">`;
            this.sendEmailData.dataHtml += `<head><meta name="viewport" content="width=device-width" /><meta http-equiv="Content-Type" content="text/html; charset=UTF-8" /><title>Facture generate</title>`;
            this.sendEmailData.dataHtml += '<style type="text/css">#invoiceprint{display:none}.vld-overlay{display: none;}.login-or { position: relative; color: rgb(0 0 0 / 55%); margin-top: 10px; margin-bottom: 10px; padding-top: 10px; padding-bottom: 10px; } .hr-or { height: 2px; margin-top: 0px !important; margin-bottom: 0px !important; border: 0; border-top: 2px dashed rgb(0 0 0 / 55%); } .span-or { display: block; position: absolute; left: 47%; top: -2px; margin-left: -25px; background-color: #fff; width: 190px; text-align: center; font-weight: 700; }.text-xs { font-size: 0.75rem; }.font-semibold { font-weight: 600; }.text-center { text-align: center; } .pl-3 { padding-left: 0.75rem; }.pr-2 { padding-right: 0.5rem; } .p-1 { padding: 0.25rem; }#detailP{font-family: system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";}.no-display{display: none !important;}.no-border{border: none;}.text-xs{font-size: 0.75rem;}.text-gray-600{color: #718096;}td {display: table-cell;vertical-align: inherit;}.text-green-700{color: #2f855a;}.invoice { display: flex; } .invoice-title { color: #999; font-size: 1.875rem; line-height: 2.25rem; margin-bottom: 0; font-weight: 700; text-transform: uppercase; } .invoice-des { text-align: right; margin-left: auto; } .invoice-logo{ margin-left: auto; width: 10.5rem; height: auto; display: block; vertical-align: middle; } caption { display: table-caption;text-align: -webkit-center;line-height: 0.5;background: #cdcdcd; font-weight: bold; font-size: 14px; margin-left: -1px; /* Fix FF 1px issue */ } .mb-6 { margin-bottom: 0.7rem; }.items-center{ align-items: center;} .align-items-center{ align-items: center !important; } .text-blue { color: #3182ce; } .row { display: flex; flex-wrap: wrap; } .text-sm-end { text-align: right; } .col-sm-5 { flex: 0 0 auto; width: 41.66666667%; } .text-sm-start { text-align: left; } .mb-sm-0 { margin-bottom: 0; } .mb-0 { margin-bottom: 0; } .mb-3 { margin-bottom: 1rem; } .imgg { vertical-align: inherit; width: 40px; display: inline-block; } .v-super{ vertical-align:super } .col-sm-7 { flex: 0 0 auto; width: 58.33333333%; } .h4 { font-size: 1.5rem; color: #0c2f54; } .p { line-height: 1.9; margin-top: 0; margin-bottom: 1rem; } .text-2xl { font-size: 1.5rem; } .pl-4 { padding-left: 1rem; } .border-l-2 { border-left-width: 2px !important;; border-color: #3182ce !important; } .mt-10{ margin-top: 10px; } .text-xss { font-size: 0.70rem !important; } .border-blue-600 { border-color: #3182ce; } .p-4 { padding: 1rem; } .mt-4 { margin-top: 1rem; } .tracking-wider { letter-spacing: 0.05em; } .text-gray-600 { color: #718096; } .text-left { text-align: left; } .text-blue-700 { color: #114f8f; } .px-6 { padding-left: 1.5rem; padding-right: 1.5rem; } .p-bb{ padding-bottom: 4px; } .py-3 { padding-top: 0.55rem; padding-bottom: 0.55rem; } .leading-4 { line-height: 1rem; } .border-b-2 { border-bottom-width: 2px; border-color: #e2e8f0 !important; } .border-t-2 { border-top-width: 2px; border-color: #e2e8f0 !important; } .border-gray-300 { border-color: #e2e8f0; } .bg-gray-200 { background-color: #edf2f7; } .h-auto { height: auto; } .bg-gray-100 { background-color: #f7fafc; } .border-dashed { border-style: dashed; } .border-gray-800 { border-color: #2d3748; } .text-xs { font-size: 0.55rem; } .font-semibold { font-weight: 600; } .dis-none{ display: none; } .text-gray-700 { color: #262728; } .rounded-full { border-radius: 9999px; } .border-b { border-bottom-width: 1px; border-color: #e2e8f0 !important; } .border-gray-200 { border-color: #8e9193; } tbody { display: table-row-group; vertical-align: middle; border-color: inherit; } tr { display: table-row; vertical-align: inherit; border-color: inherit; } .px-5 { padding-left: 1.10rem; padding-right: 1.10rem; } .width-40{ width: 50% !important; } .mb-3 { margin-bottom: 0.75rem; } sup { top: -0.5em; } .mt-10{ margin-bottom: 10px; } .border-b { border-bottom-width: 1px; border-color: #e2e8f0 !important; } .border-t { border-top-width: 1px; border-color: #e2e8f0 !important; } .text-xl { font-size: 1.25rem; } sub, sup { font-size: 75%; line-height: 0; position: relative; vertical-align: baseline; } .pt-4 { padding-top: 1rem; } .text-m { font-size: 18px; } .text-right { text-align: right; } .text-gray-900 { color: #1a202c; } .flex-1 { flex: 1 1 0%; } .py-2 { padding-top: 0.5rem; padding-bottom: 0.5rem; } .ml-auto { margin-left: auto; } .min-w-full { min-width: 100%; } .mt-5 { margin-top: 1.25rem; } table { display: table; border-collapse: collapse; box-sizing: border-box; text-indent: initial; border-spacing: 2px; border-color: grey; } .p-2 { padding: 0.5rem; } .ml-1 { margin-left: 0.25rem; } .overflow-visible{white-space: initial;}.trakingn img{width: 50%;}.mb-0{margin-bottom: 0px;}.w-1/4{width: 25%;}.w-3/4{width: 75%;}.m-0{margin:0}.pt-0{padding-top: 0px;}.mt-0{margin-top: 0px;}.py-1{padding-top: 0.25rem;padding-bottom: 0.25rem;}.px-3{padding-left: 0.75rem;padding-right: 0.75rem;}.w-2/4{width: 50%;}.mt-1{margin-top: 0.25rem;}.align-top{vertical-align: top;}p{margin:0}table{border-collapse: collapse;}table th, table td {border:1px solid #000;}.text-right{text-align:right}.flex-1{flex:1 1 0%}.w-40{width: 28rem;}.font-medium{font-weight:500}.py-1{padding-top:.25rem;padding-bottom:.25rem}.inline-block{display:inline-block}.mb-3{margin-bottom:.75rem}.py-2{padding-top:.5rem;padding-bottom:.5rem}.ml-auto{margin-left:auto}.border-black{border: 1px solid black;}.border{border-width:1px}.whitespace-no-wrap{white-space:nowrap}.text-center{text-align:center}.w-1/4{width: 25%}.text-left{text-align:left}.px-2{padding-left:.5rem;padding-right:.5rem}.min-w-full{min-width:100%}.mb-5{margin-bottom:1.25rem}.px-1{padding-left:.25rem;padding-right:.25rem}.mx-auto{margin-left:auto;margin-right:auto}body{font-family: system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";font-size:1em}.justify-between{justify-content:space-between}.w-full{width:100%}.block{display:block}.flex{display:flex}.uppercase{text-transform: uppercase;}.mb-2{margin-bottom: 0.5rem;}.mb-3{margin-bottom: 0.75rem;}.font-bold{font-weight: 700;}.font-semibold{font-weight:600}.text-xl{font-size: 1.25rem;line-height: 1.75rem;}.size-m{font-size: 12px;font-weight: 500;}@media print {@page {size:  auto; margin: 0mm;}}</style>';
            this.sendEmailData.dataHtml += '</head><body>';
            this.sendEmailData.dataHtml += $("#detailInvoice").html();
            this.sendEmailData.dataHtml += '</body></html>';
            const dataSndEmail = await this.$server.sendEmail("users", this.sendEmailData);
        }
    },
};
</script>

<style scoped>
.mx-input{
    border: none;
    box-shadow: none;
    -webkit-box-shadow: none;
    background-color: inherit;
    padding-top: 0;
}
.border-2{
    border-width: 2px;
}
.border-left-dashed {
    border-left: 2px dashed #8d9091;
}

.box-email {
    overflow: auto;
    position: absolute;
    top: 0px;
    width: 100%;
    box-sizing: border-box;
    box-shadow: 0 -4px 1px -4px rgb(0 0 0 / 10%);
    z-index: 1;
}

.spinner_S1WN {
    animation: spinner_MGfb .8s linear infinite;
    animation-delay: -.8s
}

.spinner_Km9P {
    animation-delay: -.65s
}

.spinner_JApP {
    animation-delay: -.5s
}

@keyframes spinner_MGfb {

    93.75%,
    100% {
        opacity: .2
    }
}


.mt-2 {
    margin-top: 0.5rem !important;
}

.border-top {
    border-top: 2px dashed #8d9091 !important;
}

.table-nowrap td,
.table-nowrap th {
    white-space: nowrap;
}

.table-borderless>:not(caption)>*>* {
    border-bottom-width: 0;
}

.align-middle {
    vertical-align: middle !important;
}

.siz12 {
    font-size: 12px;
}

.loading-amount svg {
    width: 20px;
}

.item-tab {
    animation-duration: 1s;
    animation-fill-mode: both;
    animation-name: fadeInUp;
}

@keyframes fadeInUp {
    from {
        opacity: 0;
        transform: translateY(10%) scale(0.9);
    }

    to {
        opacity: 1;
        transform: translateY(0%) scale(1.0);
    }
}

.btn-16::after {
    position: absolute;
    content: "";
    width: 0;
    height: 100%;
    top: 0;
    left: 0;
    direction: rtl;
    z-index: -1;
    box-shadow: -7px -7px 20px 0px #fff9, -4px -4px 5px 0px #fff9, 7px 7px 20px 0px #0002, 4px 4px 5px 0px #0001;
    transition: all 0.3s ease;
}

.custom-btn {
    height: 40px;
    border-radius: 5px;
    padding: 10px 25px;
    font-family: 'Lato', sans-serif;
    font-weight: 500;
    background: transparent;
    cursor: pointer;
    transition: all 0.3s ease;
    position: relative;
    display: inline-block;
    box-shadow: inset 2px 2px 2px 0px rgba(255, 255, 255, .5), 7px 7px 20px 0px rgba(0, 0, 0, .1), 4px 4px 5px 0px rgba(0, 0, 0, .1);
    outline: none;
    border: none;
    color: #000;
}

.btn-16:hover:after {
    left: auto;
    right: 0;
    width: 100%;
}

.total-amount svg {
    width: 35px;
}

.text-xss {
    font-size: 11px;
}

.toggle__dot {
    top: -.25rem;
    left: -.25rem;
    transition: all 0.3s ease-in-out;
}

input:checked~.toggle__dot {
    transform: translateX(100%);
    background-color: #63b3ed;
}

.flag-img {
    display: inline-block;
    height: 16px;
    vertical-align: text-top;
    line-height: 16px;
    margin-right: 5px;
}

.tag_cities {
    width: 100%;
    max-width: 100%;
}

.vs__dropdown-toggle {
    border: none;
}

.tag_cities .tag {
    background: rgb(49 130 206 / 16%);
    border-radius: 20px;
    float: left;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    font-size: .8rem;
    font-weight: 500;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    margin-right: 2px;
    margin-bottom: 5px;
    min-height: 28px;
    padding-right: 10px;
    color: rgba(0, 0, 0, 0.7);
    position: relative;
    padding-right: 0;
}

.vs-chip--text {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    margin-left: 10px;
}

.vs-chip--close {
    width: 20px;
    height: 20px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    border-radius: 50%;
    border: 0;
    margin: 0 4px;
    cursor: pointer;
    background: rgba(0, 0, 0, .15);
    color: #fff;
    -webkit-transition: all .3s ease;
    transition: all .3s ease;
    cursor: pointer;
}

.tag_cities .tag [data-role="remove"]::after {
    content: "x";
    padding: 0px 2px;
    margin-bottom: 3px;
    font-size: 15px;
}

.tag_cities .tag [data-role="remove"] {
    margin-left: 8px;
    cursor: pointer;
}

.top-100 {
    top: 100%;
}

.bottom-100 {
    bottom: 100%;
}

.max-h-select {
    max-height: 300px;
}

[type="checkbox"] {
    box-sizing: border-box;
    padding: 0;
}

.form-payement {
    min-height: 400px;
}

dialog[open] {
    animation: appear 0.15s cubic-bezier(0, 1.8, 1, 1.8);
}

dialog::backdrop {
    background: linear-gradient(45deg, rgba(0, 0, 0, 0.5), rgba(54, 54, 54, 0.5));
    backdrop-filter: blur(3px);
}
</style>
